export default {
  common: { loading: 'Laden…', noData: 'Keine Daten', clear: 'Leeren', delete: 'Löschen' },
  errors: { /* notices-i18n */
    generic: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'An diesem Tag ist eine ganztägige genehmigte Abwesenheit eingetragen – dafür lässt sich keine Arbeitszeit erfassen.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Laut Vertrag buchst du keine Arbeitszeit, nur Projektzeit.',
      week_approved: 'Diese Woche ist bereits freigegeben und gesperrt – Änderungen nur per Korrekturantrag.',
      week_submitted: 'Diese Woche ist eingereicht und wartet auf eine Entscheidung – Änderungen erst, wenn sie zurückgezogen oder zurückgegeben wurde.',
      already_clocked_in: 'Du bist bereits eingestempelt. Schließe die laufende Arbeitszeit zuerst.',
      block_overlap: 'Diese Arbeitszeit überschneidet sich mit einer anderen.',
      block_locked: 'Diese Arbeitszeit ist durch eine abgeschlossene Woche gesperrt. Beantrage stattdessen eine Korrektur.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Schalte „Anmeldung nur über SSO erzwingen“ aus, bevor du die Issuer-URL oder die Client-ID änderst.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'Eine der E-Mail-Domains ist keine Domain. Gib Domains wie example.com ein, ohne Platzhalter oder Webadressen.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Dieses Feld ist als besondere Kategorie erklärt; die Angabe lässt sich nicht zurücknehmen.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Eine Lücke kann nicht mit nichts gefüllt werden.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Diesen Namen kennt dieser Hinweis nicht als Lücke.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Ein Wert darf selbst keine Lücke enthalten.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Einladungen sind pausiert, bis alle Lücken in den Hinweisen für Mitarbeitende unter „Rechtliche Hinweise“ ausgefüllt sind. Bitte den Workspace-Inhaber, eine Suite-Administration oder die Datenschutzbeauftragte, sie zu vervollständigen.',
      LEGAL_READINESS_UNAVAILABLE: 'Wir konnten nicht prüfen, ob die Hinweise für Mitarbeitende vollständig sind. Bitte versuch es in ein paar Minuten erneut.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Abrechnung', status: 'Status', paymentMethod: 'Zahlungsmethode',
    updateCard: 'Karte ersetzen', addCard: 'Karte hinzufügen',
    invoices: 'Rechnungen', charges: 'Zahlungen',
    noInvoices: 'Noch keine Rechnungen.', noCharges: 'Noch keine Zahlungen.',
    noCard: 'Keine hinterlegt', validUntil: 'gültig bis {date}',
    trialDaysLeft: 'Noch {days} Tage Testphase', trialExpired: 'Testphase abgelaufen',
    trialDaysLeftUntil: 'Noch {days} Tage Testphase — endet am {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: 'Noch {days} Tage kostenlos — bis {date}',
    nextChargeOn: 'Nächste Abrechnung am {date}',
    exempt: { badge: 'Kostenfrei', note: 'lumi hat für diesen Workspace vereinbart, dass aktuell keine Kosten anfallen.' },
    download: 'Herunterladen', dangerZone: 'Gefahrenzone',
    col: { date: 'Datum', period: 'Zeitraum', net: 'Netto', vat: 'USt.', gross: 'Brutto', status: 'Status', kind: 'Art', amount: 'Betrag', document: 'Rechnung' },
    statusLabel: { trialing: 'Testphase', active: 'Aktiv', delinquent: 'Zahlung offen', closed: 'Beendet', canceled: 'Gekündigt' },
    tab: { plans: 'Pläne', paymentMethod: 'Zahlungsmethode', invoices: 'Rechnungen & Zahlungen', referral: 'Empfehlungen', externalPostings: 'Stellenanzeigen', dangerZone: 'Kündigen & Löschen' },
    externalPostings: {
      title: 'Externe Stellenanzeigen',
      intro: 'Anzeigen auf externen Jobbörsen werden einzeln bestellt und pro Bestellung abgerechnet – bis zu mehreren tausend Euro je Bestellung. Wenn das eingeschaltet ist, kann bestellen, wessen Recruiting-Rolle das Recht „Extern schalten (kostenpflichtig)“ hat – anfangs nur die Recruiting-Admins; jede Bestellung wird diesem Workspace berechnet.',
      switchLabel: 'Bestellung von Anzeigen auf externen Jobbörsen erlauben',
      saving: 'Wird gespeichert',
      offHint: 'Ausschalten stoppt nur neue Bestellungen. Bereits laufende Anzeigen bleiben online und werden bis zum Ende ihrer Laufzeit weiter abgerechnet.',
      offHintOpenOrders: 'Aktuell laufen Anzeigen. Ausschalten stoppt nur neue Bestellungen – die laufenden Anzeigen bleiben online und werden bis zum Ende ihrer Laufzeit weiter abgerechnet.',
      roleNote: 'Diese Einstellung können nur Workspace-Inhaber, Billing-Manager oder Suite-Admins ändern. Wer keine Anzeigen bestellen soll, dem entziehst du stattdessen im Recruiting das Recht „Extern schalten (kostenpflichtig)“.',
      demoNote: 'Das ist ein Demo-Workspace. Seine Einstellungen werden beim echten Setup ersetzt, deshalb bleibt dieser Schalter bis dahin gesperrt.',
      noCardTitle: 'Keine Zahlungsmethode hinterlegt',
      noCardBody: 'Du kannst das jetzt einschalten, aber eine Anzeigenbestellung kann erst bezahlt werden, wenn eine Karte hinterlegt ist.',
      noCardCta: 'Karte hinterlegen',
      savedOn: 'Externe Stellenanzeigen sind eingeschaltet. Recruiter sehen den Bestellbereich beim nächsten Seitenaufruf.',
      savedOff: 'Externe Stellenanzeigen sind ausgeschaltet. Neue Anzeigen können nicht mehr bestellt werden; bereits laufende Anzeigen bleiben online und werden weiter abgerechnet.',
    },
    invoiceStatus: { draft: 'Wird erstellt', issued: 'Ausgestellt', sent: 'Versendet', canceled: 'Storniert' },
    chargeKind: { subscription: 'Abonnement', proration: 'Anteilige Abrechnung', posting: 'Stellenanzeige', recovery: 'Nachzahlung' },
    posting: { orderRef: 'Auftrag {ref}', invoice: 'Rechnung herunterladen' },
    chargeStatus: { created: 'Erstellt', pending: 'Ausstehend', paid: 'Bezahlt', failed: 'Fehlgeschlagen', authorized: 'Reserviert', order_placed: 'Beauftragt', capture_requested: 'Einzug angefordert', captured: 'Bezahlt', settled: 'Bezahlt', refunded: 'Erstattet', chargeback: 'Rückbuchung', voided: 'Fehlgeschlagen' },
    bill: { label: 'Rechnung {number}', labelMany: 'Rechnungen {number}', unnumbered: 'Rechnung wird erstellt', paid: 'Bezahlt', closed: 'Abgeschlossen', retry: 'Wiederholung', projected: 'Voraussichtlich' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Testphase bis {start} · dann 1 Gratismonat bis {end} · Code {code} | Testphase bis {start} · dann {n} Gratismonate bis {end} · Code {code}', run: 'Gratismonate bis {end} · Code {code}', discount: 'Testphase bis {start} · danach 1 Monat {percent} % Rabatt auf Plätze und Module · Code {code} | Testphase bis {start} · danach {n} Monate {percent} % Rabatt auf Plätze und Module · Code {code}', discountRun: '{percent} % Rabatt auf Plätze und Module bis {end} · Code {code}', invoiceLine: 'Aktionscode {code} −{percent} %', referralLine: 'Empfehlungsbonus −{percent} %', referralLineCapped: 'Empfehlungsbonus −{percent} % (gedeckelt)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Aktionscode (optional)', apply: 'Einlösen', remove: 'Entfernen', applied: '{code}: {percent} % Rabatt auf {module} für 1 Rechnung | {code}: {percent} % Rabatt auf {module} für {n} Rechnungen', savesToday: 'Der Code nimmt {amount} von der heutigen Abbuchung ab.', rateLimited: 'Zu viele Versuche. Warte ein paar Minuten und versuch es dann noch einmal.', checkFailed: 'Der Code lässt sich gerade nicht prüfen. Du kannst das Modul auch ohne ihn hinzufügen.', notBooked: 'Es wurde nichts gebucht – du kannst das Modul ohne den Code hinzufügen.', addedWithoutDiscount: 'Der Code konnte nicht angewendet werden, deshalb gibt es keinen Rabatt.', module: { time_tracking: 'Zeiterfassung' }, trimmed: '{code} gibt {percent} %, aber auf deiner Rechnung liegt schon ein Rabatt – auf {module} bekommst du {effective} % (alle Rabatte zusammen auf einer Rechnung sind gedeckelt).', trimmedNothing: '{code} gibt {percent} %, aber auf deiner Rechnung liegt schon ein Rabatt – dieser Code bringt gerade nichts obendrauf.', pending: 'Wir bestätigen deinen Code noch – er erscheint auf deiner nächsten Rechnung, sobald er bestätigt ist.', invoiceLine: 'Aktionscode {code} −{percent} % ({module})', running: '{code}: {percent} % Rabatt auf 1 weitere Rechnung | {code}: {percent} % Rabatt auf {n} weitere Rechnungen', reason: { unknown: 'Diesen Code kennen wir nicht. Prüf bitte die Schreibweise.', disabled: 'Dieser Code wurde abgeschaltet.', notYetValid: 'Dieser Code gilt noch nicht.', expired: 'Dieser Code ist abgelaufen.', exhausted: 'Du hast diesen Code schon verwendet, oder er ist aufgebraucht.', moduleNotEligible: 'Dieser Code gilt nicht für {module}.', wrongCheckout: 'Dieser Code gilt für Neuanmeldungen, nicht fürs Hinzufügen eines Moduls.', unavailable: 'Diesen Code kannst du hier nicht verwenden.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Dein Empfehlungscode', copy: 'Code kopieren', copyLink: 'Checkout-Link kopieren', copied: 'Empfehlungscode kopiert', linkCopied: 'Checkout-Link kopiert', friendGets: 'Wer deinen Code nutzt, bekommt {percent} % Rabatt auf den ersten bezahlten Monat. | Wer deinen Code nutzt, bekommt {percent} % Rabatt auf die ersten {n} bezahlten Monate.', youGet: 'Für jedes Unternehmen, das mit deinem Code zu zahlen beginnt: {percent} % Rabatt auf eine deiner Rechnungen — mehrere addieren sich, bis zu {ceiling} % pro Rechnung. | Für jedes Unternehmen, das mit deinem Code zu zahlen beginnt: {percent} % Rabatt auf {n} deiner Rechnungen — mehrere addieren sich, bis zu {ceiling} % pro Rechnung.', youGetCapped: 'Für jedes Unternehmen, das mit deinem Code zu zahlen beginnt: {percent} % Rabatt auf eine deiner Rechnungen — mehrere addieren sich, bis zu {ceiling} % pro Rechnung; jeder Bonus bringt dir höchstens {cap} pro Rechnung. | Für jedes Unternehmen, das mit deinem Code zu zahlen beginnt: {percent} % Rabatt auf {n} deiner Rechnungen — mehrere addieren sich, bis zu {ceiling} % pro Rechnung; jeder Bonus bringt dir höchstens {cap} pro Rechnung.', paused: 'Dein Code ruht, solange für deinen Workspace ein Löschantrag offen ist. Sobald er zurückgenommen wird, funktioniert der Code wieder.', disabled: 'Dieser Code wurde abgeschaltet und kann nicht mehr eingelöst werden.', none: { trialing: 'Einen Empfehlungscode bekommst du, sobald dein Workspace bezahlt, also nach der Testphase.', free_run: 'Einen Empfehlungscode bekommst du, sobald die Gratismonate vorbei sind und dein Workspace bezahlt.', not_billing: 'Einen Empfehlungscode bekommst du, sobald dein Workspace ein laufendes Abo hat.' }, loading: 'Dein Empfehlungscode wird geladen …', error: 'Dein Empfehlungscode konnte gerade nicht gelesen werden. Versuche es später noch einmal.', bonus: { title: 'Deine Empfehlungsboni', collect: 'Einlösen', ready: 'wartet darauf, eingelöst zu werden', startsOn: 'beginnend mit deiner Rechnung vom {date}', startsNext: 'beginnend mit deiner nächsten Rechnung', waits: 'wartet auf Platz auf einer kommenden Rechnung', carries: 'Deine nächste Rechnung enthält {items}.', capped: 'gedeckelt', running: { promo: '{percent} % Aktionscode', module: '{percent} % Modulcode', referral: '{percent} % Empfehlungsbonus' }, collected: 'Eingelöst — der Bonus wird jetzt von deinen nächsten Rechnungen abgezogen.', alreadyRunning: 'Dieser Bonus läuft bereits.', collectFailed: 'Der Bonus konnte gerade nicht eingelöst werden. Versuche es bitte noch einmal.', hint: { ceiling: 'Noch nicht: Deine nächste Rechnung enthält schon {running}, und mit diesem Bonus läge sie über der Grenze von {ceiling} %.', ceilingRunning: 'Noch nicht: Deine nächste Rechnung enthält schon {running}, da ist für diesen Bonus kein Platz mehr.', ceilingLimit: 'Noch nicht: Mit diesem Bonus läge deine nächste Rechnung über der Grenze von {ceiling} %.', ceilingPlain: 'Noch nicht: Die Rabatte auf deiner nächsten Rechnung lassen für diesen Bonus keinen Platz.', roomNext: 'Ein laufender Bonus endet mit deiner nächsten Rechnung.', roomLater: 'Der erste laufende Bonus endet nach {n} weiteren Rechnungen.', notActive: 'Dieser Bonus wartet, bis dein Workspace wieder aktiv ist.', deletion: 'Dieser Bonus wartet, solange für deinen Workspace ein Löschantrag offen ist.', unavailable: 'Ob dieser Bonus eingelöst werden kann, lässt sich gerade nicht prüfen. Versuche es gleich noch einmal.' } }, history: { title: 'Deine Empfehlungen', empty: 'Bisher hat noch niemand deinen Code genutzt.', waiting: 'Genutzt am {date} — wartet auf den ersten bezahlten Monat', bonusEarned: 'Verdient am {date}: {percent} % Rabatt auf 1 Rechnung | Verdient am {date}: {percent} % Rabatt auf {n} Rechnungen', bonusCap: ', gedeckelt auf {cap} pro Rechnung', bonusOn: 'auf deiner Rechnung für {months} | auf deinen Rechnungen für {months}', bonusToCome: '1 folgt noch | {n} folgen noch', bonusNone: 'noch auf keiner Rechnung' } },
    errors: { setupFailed: 'Karteneinrichtung fehlgeschlagen.', loadFailed: 'Abrechnungsdaten konnten nicht geladen werden.', ownerOnly: 'Nur der Workspace-Eigentümer kann die Abrechnung verwalten.', planChangeFailed: 'Plan konnte nicht geändert werden. Bitte erneut versuchen.', paymentStanding: 'Bitte begleiche die offene Zahlung, bevor du upgradest.', cardRequired: 'Bitte hinterlege eine gültige Karte, bevor du upgradest.', addModuleFailed: 'Modul konnte nicht hinzugefügt werden. Bitte erneut versuchen.', cancellationPending: 'Dein Abonnement endet demnächst. Wähle zuerst „Abonnement behalten“ und füge das Modul dann hinzu.', removeFailed: 'Entfernung konnte nicht geplant werden. Bitte erneut versuchen.' },
    retry: 'Erneut versuchen',
    common: { close: 'Schließen' },
    card: {
      label: 'Karte', title: 'Zahlungsmethode',
      remove: 'Karte entfernen', removed: 'Karte entfernt.',
      inUse: 'Diese Karte wurde bereits abgerechnet und kann nur ersetzt, nicht entfernt werden.',
      removeConfirmTitle: 'Karte entfernen?', removeConfirmBody: 'Damit wird die hinterlegte Karte entfernt. Du kannst jederzeit eine neue hinzufügen.',
      removeError: 'Karte konnte nicht entfernt werden.',
      handoff: 'Zahlungslink an Dritte senden', handoffTitle: 'Zahlungslink',
      handoffHint: '„Karte hinzufügen/ersetzen“: Du gibst die Kartendaten selbst ein. „Zahlungslink an Dritte senden“: Du sendest einen einmaligen Link an die Person, die die Karte einrichtet – z. B. deine Buchhaltung.',
      handoffBody: 'Teile diesen einmaligen Link mit der Person, die die Karte einrichtet. Er läuft am {date} ab.',
      copy: 'Kopieren', copied: 'Kopiert', handoffCopied: 'Zahlungslink kopiert', handoffError: 'Zahlungslink konnte nicht erstellt werden.',
    },
    recovery: {
      title: 'Zahlung ausstehend · {amount}',
      body: 'Deine Bank muss diese Zahlung bestätigen. Bestätige sie jetzt, damit dein Zugang erhalten bleibt.',
      cta: 'Zahlung bestätigen',
      paid: 'Zahlung eingegangen – dein Zugang ist wiederhergestellt.',
      failed: 'Die Zahlung wurde nicht abgeschlossen. Du kannst es jederzeit erneut versuchen.',
      checking: 'Wir prüfen die Zahlung noch…',
      startError: 'Die Zahlung konnte gerade nicht gestartet werden. Bitte versuche es gleich noch einmal.',
    },
    plan: {
      title: 'Plan & Module', subtitle: 'Verwalte den Plan für jedes aktive Modul.',
      currentPlan: 'Aktueller Plan', current: 'Aktuell',
      perMonth: '{amount}/Mon.', perUserMonth: '{amount} pro Nutzer/Mon.', perApprenticeMonth: '{amount} pro Azubi/Mon.', volumeHint: 'Mengenrabatt: Größere Workspaces zahlen automatisch weniger pro Platz.',
      perUpgradeMonth: '{amount} pro Erweiterung/Mon.',
      upgrade: 'Upgraden', downgrade: 'Downgraden', apply: 'Plan ändern',
      downgradeNote: 'Downgrades werden zu Beginn deines nächsten Abrechnungszeitraums wirksam.',
      fixCardCta: 'Zahlungsmethode korrigieren',
      enterprise: { title: 'Mehr benötigt?', body: 'Größere Teams und individuelle Konditionen vereinbaren wir mit unserem Team.', cta: 'Vertrieb kontaktieren' },
      provisioning: 'Wird eingerichtet – das kann eine Minute dauern.',
      provisioningFailed: 'Einrichtung fehlgeschlagen – wir kümmern uns darum.',
      removeModule: 'Modul entfernen', removeConfirmTitle: 'Modul entfernen?',
      removeConfirmBody: '{module} wird zum Ende deines aktuellen Abrechnungszeitraums entfernt. Bis dahin kannst du das rückgängig machen.',
      removeScheduled: 'Entfernung von {module} geplant.',
      addTitle: 'Modul hinzufügen', addSubtitle: 'Erweitere deinen Workspace um ein weiteres Modul.',
      addCta: 'Modul hinzufügen', addConfirmTitle: 'Modul hinzufügen?',
      moduleLabel: 'Modul', planLabel: 'Plan',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Preis', seats: 'Plätze', monthly: 'Monatlich', from: 'ab {date}' },
      apprenticeSeats: 'Gebuchte Azubi-Plätze',
      apprenticeSeatsHint: 'Mindestens 1 Azubi-Platz für das Ausbildungsmodul.',
      apprenticeSeatsCeiling: 'Ab {max} Azubi-Plätzen gibt es keinen Self-Service-Tarif – wir stimmen ihn direkt mit dir ab:',
      apprenticeSeatAdjustment: 'Du hattest {booked} Azubi-Plätze gebucht, bevor dieses Modul entfernt wurde, daher wurde es mit {booked} statt der angefragten {requested} wieder hinzugefügt. Du kannst sie ab deiner nächsten Abrechnung reduzieren.',
      added: '{module} hinzugefügt.',
      addedPaymentRetrying: '{module} wurde hinzugefügt und ist einsatzbereit. Die Zahlung konnten wir gerade nicht einziehen – wir versuchen es automatisch erneut.',
      alreadyActive: '{module} ist bereits in deinem Plan enthalten.',
    },
    seats: {
      title: 'Gebuchte Plätze',
      userSeats: 'Nutzerplätze', apprenticeSeats: 'Azubi-Plätze',
      stepUp: 'Mehr Plätze', stepDown: 'Weniger Plätze',
      bookMore: 'Weitere Plätze buchen',
      confirmTitle: 'Weitere Plätze buchen?', confirmCta: 'Plätze buchen',
      chargeNote: 'Zusätzliche Plätze werden anteilig für den Rest dieses Abrechnungszeitraums berechnet.',
      confirmTitleDecrease: 'Gebuchte Plätze reduzieren?',
      reduceCta: 'Plätze reduzieren',
      decreaseNote: 'Heute wird nichts berechnet oder gutgeschrieben – deine Buchung ändert sich am {date}.',
      decreaseNoteImmediate: 'Es wird nichts berechnet oder gutgeschrieben – deine Buchung ändert sich sofort.',
      decreaseScheduled: 'Reduzierung der Plätze für den {date} geplant.',
      mixedDirection: 'Buche zusätzliche Plätze und reduziere Plätze in getrennten Schritten: zusätzliche Plätze werden heute berechnet, reduzierte Plätze gelten ab deiner nächsten Abrechnung.',
      belowUsage: 'Dein Workspace nutzt mehr Plätze als das. Behalte mindestens {count}.',
      usageCheckUnavailable: 'Wir konnten gerade nicht prüfen, wie viele Plätze belegt sind. Bitte versuche es gleich noch einmal.',
      leaveFreelancer: 'Damit verlässt du den Freelancer-Modus.',
      returnFreelancer: 'Damit kehrst du in den Freelancer-Modus zurück – eine Person, ein Platz.',
      booked: 'Deine gebuchten Plätze wurden aktualisiert.',
      bookedPaymentRetrying: 'Deine Plätze sind gebucht und sofort nutzbar. Die Zahlung konnten wir gerade nicht einziehen – wir versuchen es automatisch erneut.',
      bookFailed: 'Die Plätze konnten nicht gebucht werden. Bitte versuche es erneut.',
    },
    seatPanel: {
      inUse: '{used} von {booked} belegt',
      bookedOnly: '{booked} gebucht',
      useUnknown: 'Wir konnten gerade nicht ermitteln, wie viele belegt sind.',
      manage: 'Plätze verwalten',
      pendingUsers: 'Die Nutzerplätze ändern sich am {date} auf {target} – bis dahin sind {current} gebucht.',
      pendingApprentices: 'Die Azubi-Plätze ändern sich am {date} auf {target} – bis dahin sind {current} gebucht.',
      reflooredUsers: 'Deine Reduzierung auf {requested} Nutzerplätze wurde mit {booked} übernommen: {used} Personen sind im Workspace und jede belegt einen Platz. Entferne die Personen, die du nicht mehr brauchst, und reduziere dann erneut.',
      reflooredApprentices: 'Deine Reduzierung auf {requested} Azubi-Plätze wurde mit {booked} übernommen: {used} Ausbildungen laufen. Beende die, die du nicht mehr brauchst, und reduziere dann erneut.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Azubis aus den Demodaten belegen keine gebuchten Plätze – sie zählen hier nicht mit und verschwinden, sobald du die Demo übernimmst.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Was diese Buchung kostet',
      includes: 'Was deine Buchung enthält – und was sie im Monat kostet.',
      userSeatsCount: '{count} Nutzerplätze',
      apprenticeSeatsCount: '{count} Azubi-Plätze',
      aiQuotaUpgradesCount: '{count} × Erweiterung',
      subtotal: 'Zwischensumme',
      volumeDiscount: 'Mengenrabatt',
      monthlyTotal: 'Monatlich gesamt',
      currentTotal: 'Heute zahlst du {amount} im Monat.',
      newMonthlyTotal: 'Ab der nächsten Rechnung: {amount} im Monat.',
      netNote: 'Alle Preise zzgl. MwSt. Beim Buchen zusätzlicher Plätze kommt einmalig der anteilige Betrag für den Rest des laufenden Abrechnungszeitraums dazu.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'KI-Kontingent',
      usageLink: 'Wofür es verbraucht wird',
      ownKey: 'Dieser Workspace nutzt lumi mit einem eigenen KI-Anbieter-Key und hat deshalb kein KI-Kontingent – jedes Token rechnet dein Anbieter direkt mit dir ab.',
      suspended: 'Solange der Workspace gesperrt ist, ist das KI-Kontingent ausgesetzt.',
      unlimited: 'Für diesen Workspace gilt kein KI-Kontingent – lumi hat die Begrenzung aufgehoben.',
      intro: 'lumi, die KI-Funktionen aller Module und die externen KI-Agenten, die Mitglieder verbinden, nutzen ein gemeinsames Kontingent: bis zu {limit} Tokens pro Abrechnungszeitraum. Es wird zu Beginn jedes Abrechnungszeitraums zurückgesetzt; nicht verbrauchte Tokens verfallen.',
      included: 'Inklusive',
      includedDerived: 'mit deinen gebuchten Plätzen',
      includedOverride: 'von lumi für diesen Workspace festgelegt',
      tokensValue: '{tokens} Tokens pro Zeitraum',
      upgrades: 'Kontingent-Erweiterungen',
      upgradesNone: 'Keine gebucht',
      upgradesValue: '{count} gebucht · +{tokens} Tokens',
      used: 'In diesem Zeitraum verbraucht',
      usedValue: '{used} von {limit} Tokens',
      usedNoLimit: '{used} Tokens bisher',
      resetsOn: 'Wird am {date} zurückgesetzt',
      stepPrice: 'Eine Erweiterung bringt {tokens} Tokens mehr pro Abrechnungszeitraum und kostet {amount} pro Monat.',
      stepUp: 'Eine Erweiterung mehr',
      stepDown: 'Eine Erweiterung weniger',
      removeCta: 'Zum nächsten Abrechnungsdatum entfernen',
      confirmTitle: 'KI-Kontingent erweitern?',
      confirmTitleDecrease: 'Kontingent-Erweiterung entfernen?',
      confirmCta: 'Erweiterung buchen',
      trialWarning: 'Das kostet echtes Geld, auch in der Testphase: Deine Karte wird heute anteilig für den Rest der Testphase belastet, höchstens aber für einen Monat, und danach jeden Monat.',
      cardRequired: 'Für eine Erweiterung des KI-Kontingents brauchst du eine aktive Karte, auch in der Testphase. Hinterlege zuerst deine Karte – sobald sie bestätigt ist, kannst du die Erweiterung buchen.',
      promoExcluded: 'Dein Code gilt nicht für das KI-Kontingent: Eine Erweiterung wird nie rabattiert, sondern zum Listenpreis berechnet.',
      chargeNote: 'Eine Erweiterung wird jetzt anteilig für den Rest dieses Abrechnungszeitraums berechnet und gilt sofort.',
      decreaseNote: 'Heute wird nichts berechnet oder gutgeschrieben. Die Erweiterung bleibt dir bis zum {date}; danach gilt das kleinere Kontingent.',
      decreaseNoteGeneric: 'Heute wird nichts berechnet oder gutgeschrieben – die Erweiterung endet zum nächsten Abrechnungsdatum.',
      newQuota: 'Danach: bis zu {limit} Tokens pro Abrechnungszeitraum.',
      changeDelta: '{tokens} Tokens · {amount} / Monat',
      addCtaPrice: 'Kontingent erweitern · {amount} / Monat',
      booked: 'Deine Kontingent-Erweiterungen wurden aktualisiert.',
      bookedPaymentRetrying: 'Deine Kontingent-Erweiterung ist gebucht und gilt sofort. Die Zahlung konnten wir gerade nicht einziehen – wir versuchen es automatisch erneut.',
      decreaseScheduled: 'Die Kontingent-Erweiterung endet am {date}.',
      pending: 'Die Kontingent-Erweiterungen ändern sich am {date} auf {target} – bis dahin sind {current} gebucht.',
      bookFailed: 'Die Kontingent-Erweiterungen konnten nicht geändert werden. Bitte versuche es erneut.',
    },
    scheduled: {
      resizeTo: 'Wechsel zu {plan}', remove: 'Modul entfernen',
      effective: 'wirksam am {date}', revert: 'Rückgängig', reverted: 'Geplante Änderung zurückgenommen.',
    },
    proration: {
      title: 'Planänderung bestätigen', stepFrom: 'Aktuell', stepTo: 'Neu',
      chargeNote: 'Ein Upgrade wird jetzt anteilig für den Rest dieses Abrechnungszeitraums berechnet.',
      freeNote: 'Diese Änderung wird während deiner Testphase sofort und kostenfrei wirksam.',
      confirm: 'Bestätigen & upgraden', cancel: 'Abbrechen',
      charged: '{amount} berechnet.', appliedImmediate: 'Dein neuer Plan ist aktiv.',
      appliedScheduled: 'Geplant – wirksam am {date}.',
      calculating: 'Wir ermitteln den genauen Betrag …',
      chargeExact: 'Dir werden heute {amount} berechnet.',
      noChargeToday: 'Heute wird nichts berechnet.',
    },
    profile: {
      title: 'Rechnungsdaten', subtitle: 'Vervollständige deine Rechnungsdaten, um die Zahlung zu aktivieren.',
      legalName: 'Rechtlicher Firmenname', addressLine1: 'Adresse', addressLine2: 'Adresszusatz',
      postalCode: 'PLZ', city: 'Stadt', vatId: 'USt-IdNr.',
      vatOptional: 'Optional – für das Reverse-Charge-Verfahren innerhalb der EU erforderlich.',
      save: 'Daten speichern', edit: 'Rechnungsdaten bearbeiten', error: 'Deine Rechnungsdaten konnten nicht gespeichert werden.',
      saved: 'Rechnungsdaten gespeichert.',
      vatPending: 'Wir konnten deine USt-IdNr. gerade nicht prüfen. Bitte versuche es in Kürze erneut.',
      vatInvalid: 'Diese USt-IdNr. konnte nicht bestätigt werden. Bitte überprüfe sie.',
      vatRequired: 'Für dein Land ist eine gültige USt-IdNr. erforderlich, bevor du eine Karte hinzufügst.',
      completeFirst: 'Vervollständige deine Rechnungsdaten, bevor du eine Karte hinzufügst.',
    },
    cancel: {
      title: 'Abonnement kündigen',
      body: 'Kündige dein Abonnement. Dein Workspace bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.',
      reason: 'Grund (optional)', confirm: 'Abonnement kündigen', confirmTitle: 'Abonnement kündigen?',
      confirmBody: 'Dein Abonnement endet am {date}. Bis dahin funktioniert alles weiter.',
      note: 'Bis dahin läuft alles weiter, auch der Export des ganzen Workspace. Danach wird der Workspace geschlossen; seine Daten bleiben eine Weile erhalten, und die Inhaber erfahren es, bevor etwas gelöscht wird. Soll er früher verschwinden, geht das über „{deletion}“.',
      pending: 'Kündigung geplant – dein Abonnement endet am {date}.', pendingNoDate: 'Kündigung geplant.',
      revert: 'Abonnement behalten', error: 'Dein Abonnement konnte nicht gekündigt werden.',
      done: 'Kündigung geplant. Dein Workspace bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.', revertDone: 'Kündigung zurückgenommen. Dein Abonnement läuft normal weiter.',
    },
    deletion: {
      title: 'Workspace löschen (DSGVO)',
      body: 'Beantrage die dauerhafte Löschung dieses Workspace und aller Daten. Nach einer kurzen Karenzzeit ist dies unwiderruflich.',
      request: 'Löschung beantragen', reason: 'Grund (optional)',
      confirmTitle: 'Löschung des Workspace beantragen?',
      confirmBody: 'Alle Daten werden nach einer kurzen Karenzzeit dauerhaft gelöscht. Dies ist unwiderruflich.',
      pending: 'Löschung beantragt – Daten werden nach dem {date} gelöscht.', pendingNoDate: 'Löschung beantragt und in Prüfung.',
      cancel: 'Löschantrag zurückziehen', error: 'Dein Löschantrag konnte nicht übermittelt werden.',
      requested: 'Löschung beantragt. Wir löschen deinen Workspace nach der Karenzzeit.', canceled: 'Löschantrag zurückgezogen. Dein Workspace bleibt bestehen.',
      confirmType: 'Tippe zur Bestätigung den Workspace-Namen ({name}) ein',
      cancelConfirmTitle: 'Löschantrag zurückziehen?',
      cancelConfirmBody: 'Dein Workspace und alle Daten bleiben erhalten. Du kannst die Löschung jederzeit erneut beantragen.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Recruiting', time_tracking: 'Zeit', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Pro Nutzer', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Pro Nutzer', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Pro Azubi', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Pro Nutzer', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'KI-Kontingent-Erweiterung (+1.000.000 Tokens pro Abrechnungszeitraum)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Dieser Workspace ist von der Abrechnung befreit', body: 'lumi hat für diesen Workspace vereinbart, dass keine Kosten anfallen. Deshalb gibt es hier kein Abrechnungskonto, und es wird nichts berechnet — jetzt nicht und später nicht. Das kann nur lumi ändern; für dich gibt es hier nichts einzurichten.' },
      demo: { title: 'Abrechnung ist im Demo-Modus nicht verfügbar', body: 'Dieser Workspace läuft mit Demodaten, es gibt also noch nichts abzurechnen. Die Abrechnung kann eingerichtet werden, sobald du die Demo in eine echte Einrichtung überführst — das Demo-Banner oben auf der Seite startet das.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'Die Einrichtung der Abrechnung wurde nicht abgeschlossen', buyerBody: 'Deine Registrierung wurde nicht abgeschlossen, deshalb hat dieser Workspace noch kein Abrechnungskonto und es wird nichts berechnet. Du kannst das selbst abschließen: Geh zurück zum Checkout und buche dieselben Module noch einmal — damit wird dieser Workspace fortgesetzt, statt ein zweiter angelegt. Klappt es weiterhin nicht, melde dich, dann schließen wir es gemeinsam ab.', otherBody: 'Deine Registrierung wurde nicht abgeschlossen, deshalb hat dieser Workspace noch kein Abrechnungskonto und es wird nichts berechnet. Abschließen kann das nur die Person, die diesen Workspace registriert hat — indem sie zurück zum Checkout geht und dieselben Module noch einmal bucht. Bitte sie darum, oder melde dich, dann schließen wir es gemeinsam ab.', checkoutCta: 'Zurück zum Checkout', cta: 'Support kontaktieren' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Vertragsdokumente',
      terms: 'AGB',
      avv: 'Auftragsverarbeitungsvertrag (AVV)',
      tom: 'Technische und organisatorische Maßnahmen (TOM)',
      subprocessors: 'Unterauftragsverarbeiter',
    },
  },

  login: {
    ssoApple: 'Mit Apple anmelden',
    passkeySignIn: 'Mit Passkey anmelden',
    passkeySigningIn: 'Anmeldung läuft …',
    passkeyFailed: 'Die Anmeldung mit Passkey ist fehlgeschlagen. Bitte erneut versuchen oder das Passwort verwenden.',
    title: 'lumi-HR Suite',
    subtitle: 'Melde dich an, um fortzufahren',
    email: 'E-Mail',
    emailPlaceholder: "name{'@'}firma.de",
    password: 'Passwort',
    passwordPlaceholder: 'Dein Passwort',
    signIn: 'Anmelden',
    signingIn: 'Wird angemeldet…',
    failed: 'Anmeldung fehlgeschlagen',
    forgotPassword: 'Passwort vergessen?',
    lostPhone: 'Handy verloren?',
    orContinueWith: 'oder anmelden mit',
    ssoGoogle: 'Mit Google anmelden',
    ssoMicrosoft: 'Mit Microsoft anmelden',
    ssoEnterprise: 'Mit Firmen-SSO anmelden',
    ssoOnly: 'Für diesen Workspace erfolgt die Anmeldung über dein Firmen-SSO.',
    adminLogin: 'Administrator-Anmeldung',
    ssoError: 'Die SSO-Anmeldung ist fehlgeschlagen. Bitte versuch es erneut.',
    ssoSeatLimit: 'In diesem Workspace ist kein Nutzerplatz frei, deshalb konnten wir kein Konto für dich anlegen. Bitte den Workspace-Inhaber oder einen Billing Manager, einen weiteren Platz zu buchen – ein erneuter Anmeldeversuch hilft erst danach.',
    ssoLinkRequired: 'Diese Firmenanmeldung konnte nicht automatisch mit deinem lumi-Konto verbunden werden. Melde dich auf anderem Weg an und verbinde die Firmenanmeldung dann unter Konto & Sicherheit.',
    ssoEmployeeNoticeIncomplete: 'Dieser Workspace ist noch nicht bereit: Die Hinweise für Mitarbeitende haben noch offene Lücken. Bitte den Workspace-Inhaber, eine Suite-Administration oder die Datenschutzbeauftragte, sie im Bereich „Rechtliche Hinweise“ auszufüllen — ein erneuter Anmeldeversuch hilft erst danach.',
    ssoLegalReadinessUnavailable: 'Wir konnten gerade nicht prüfen, ob dieser Workspace bereit ist. Bitte versuch es in ein paar Minuten erneut.',
    ssoOperatorPasswordOnly: 'Systemadmin-Konten melden sich mit Passwort und Authenticator-App an, nicht über diesen Anbieter.',
    mfaTitle: 'Code aus der Authenticator-App eingeben',
    mfaIntro: 'Das ist ein Systemadmin-Konto. Gib den 6-stelligen Code aus deiner Authenticator-App oder einen deiner Wiederherstellungscodes ein.',
    mfaCode: 'Code',
    mfaSubmit: 'Anmelden',
    mfaBack: 'Zurück',
    mfaInvalid: 'Dieser Code ist nicht richtig.',
    mfaReused: 'Dieser Code wurde schon verwendet. Warte auf den nächsten in deiner App.',
    mfaExpired: 'Diese Anmeldung ist abgelaufen. Melde dich erneut mit deinem Passwort an.',
    mfaEnrolOnConsole: 'Für dieses Systemadmin-Konto ist noch keine Authenticator-App eingerichtet. Melde dich zuerst in der lumi-Konsole an, um sie einzurichten.',
    tenantLogoAlt: 'Workspace-Logo',
    poweredBy: 'Bereitgestellt von',
  },
  loginBranding: {
    nav: 'Anmeldeseite',
    title: 'Anmeldeseite',
    intro: 'Gib der Anmeldeseite dieses Workspace ein eigenes Logo, eine eigene Farbe und ein eigenes Hintergrundbild. Alle, die sich hier anmelden, sehen es.',
    retry: 'Erneut versuchen',
    loadFailed: 'Die aktuellen Einstellungen konnten nicht geladen werden.',
    form: {
      title: 'Erscheinungsbild',
      logo: 'Logo',
      logoHint: 'PNG, JPEG, WebP oder GIF, bis 2 MB. Leer lassen, um das lumi-Logo zu behalten.',
      image: 'Hintergrundbild',
      imageHint: 'Wird hinter der Anmeldekarte angezeigt. PNG, JPEG, WebP oder GIF, bis 8 MB.',
      upload: 'Hochladen',
      replace: 'Ersetzen',
      remove: 'Entfernen',
      empty: 'Kein Bild',
      uploaded: 'Bild hochgeladen.',
      removed: 'Bild entfernt.',
      tooLarge: 'Diese Datei ist zu groß.',
      wrongType: 'Es werden nur PNG-, JPEG-, WebP- und GIF-Bilder akzeptiert.',
      uploadFailed: 'Das Bild konnte nicht hochgeladen werden. Bitte erneut versuchen.',
      removeFailed: 'Das Bild konnte nicht entfernt werden. Bitte erneut versuchen.',
      removeConfirm: 'Das Bild wird von der Anmeldeseite entfernt und gelöscht. Das lässt sich nicht rückgängig machen.',
      primaryColor: 'Primärfarbe',
      colorPlaceholder: 'z. B. 1a2b3c',
      colorInvalid: 'Gib eine Hex-Farbe wie 1a2b3c ein.',
      clear: 'Zurücksetzen',
      save: 'Speichern',
      saved: 'Anmeldeseite aktualisiert.',
      discard: 'Verwerfen',
      liveNote: 'Gespeicherte Änderungen sind beim nächsten Aufruf der Anmeldeseite sichtbar.',
    },
    preview: {
      title: 'Vorschau',
      hint: 'So sieht die Anmeldeseite mit den Werten oben aus.',
      logoAlt: 'Logo-Vorschau',
    },
  },
  authFlow: {
    forgot: {
      title: 'Passwort zurücksetzen',
      subtitle: 'Wir senden dir einen Link zum Zurücksetzen.',
      email: 'E-Mail',
      submit: 'Link senden',
      done: 'Falls ein Konto mit dieser E-Mail existiert, haben wir einen Link zum Zurücksetzen gesendet.',
      backToLogin: 'Zurück zur Anmeldung',
    },
    reset: {
      title: 'Neues Passwort festlegen',
      password: 'Neues Passwort',
      confirm: 'Passwort bestätigen',
      submit: 'Passwort speichern',
      success: 'Dein Passwort wurde geändert. Du kannst dich jetzt anmelden.',
      goToLogin: 'Zur Anmeldung',
      invalid: 'Dieser Link ist ungültig oder abgelaufen.',
      mismatch: 'Die Passwörter stimmen nicht überein.',
      tooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
      missingToken: 'Kein gültiger Token gefunden.',
    },
    invite: {
      title: 'Konto einrichten',
      subtitle: 'Lege ein Passwort fest, um dein Konto zu aktivieren.',
      forTenant: 'Einladung zu {tenant}',
      password: 'Passwort',
      confirm: 'Passwort bestätigen',
      submit: 'Konto aktivieren',
      submitting: 'Wird aktiviert…',
      invalid: 'Diese Einladung ist ungültig oder abgelaufen.',
      mismatch: 'Die Passwörter stimmen nicht überein.',
      tooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
      passkey: {
        title: 'Anmeldung einrichten',
        intro: 'Du meldest dich bei lumi mit einem Passkey an: Fingerabdruck, Gesicht oder Geräte-PIN. Kein Passwort, das du dir merken musst.',
        sentTo: 'Gesendet an {phone}',
        create: 'Passkey erstellen',
        creating: 'Warte auf dein Gerät…',
        instead: 'Stattdessen einen Passkey verwenden',
        or: 'oder',
        unsupported: 'Dieser Browser kann keinen Passkey erstellen. Öffne den Link auf deinem Handy oder in einem aktuellen Browser.',
        unavailable: 'Passkeys sind für diesen Workspace hier nicht verfügbar. Bitte wende dich an deine Administration.',
        expired: 'Das hat zu lange gedauert. Bitte versuche es erneut.',
        alreadyRegistered: 'Dieses Gerät hat bereits einen Passkey für lumi.',
        failed: 'Der Passkey konnte nicht erstellt werden. Bitte versuche es erneut.',
      },
    },
    recover: {
      title: 'Handy verloren?',
      subtitle: 'Gib deine Handynummer ein, und wir schicken dir per SMS einen Link, mit dem du einen neuen Passkey einrichtest.',
      phone: 'Handynummer',
      phoneHint: 'Mit Ländervorwahl, z. B. +49 151 2345678',
      submit: 'Link senden',
      done: 'Falls diese Nummer zu einem Konto hier gehört, haben wir ihr einen Link geschickt. Er ist 15 Minuten gültig.',
      enrolTitle: 'Neuen Passkey einrichten',
      enrolSubtitle: 'Erstelle einen Passkey auf diesem Gerät. Alle anderen Sitzungen deines Kontos werden abgemeldet.',
      create: 'Neuen Passkey erstellen',
      invalid: 'Dieser Link ist ungültig oder abgelaufen. Fordere einen neuen an.',
    },
    verify: {
      verifying: 'E-Mail wird bestätigt…',
      success: 'Deine E-Mail-Adresse wurde bestätigt.',
      invalid: 'Dieser Bestätigungslink ist ungültig oder abgelaufen.',
      backToLogin: 'Zur Anmeldung',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'KI-Agent-Verbindungen',
      hint: 'KI-Clients, die du in einem Workspace in deinem Namen handeln lässt. Jeder arbeitet mit genau deinen Berechtigungen, und was er liest, geht an den Anbieter dieses Clients.',
      none: 'Kein KI-Agent verbunden.',
      inWorkspace: 'im Workspace {workspace}',
      scope: {
        read: 'lesen',
        act: 'handeln mit Bestätigung',
        ask: 'lumi fragen',
      },
      lastUsed: 'Zuletzt verwendet am {when}',
      connectedOn: 'Verbunden am {when}, noch nicht verwendet',
      standing: {
        label: 'Aktionen an meinen eigenen Datensätzen ohne Rückfrage ausführen',
        hint: 'Gilt nie für Datensätze anderer Personen oder für belastende Entscheidungen.',
        notOffered: 'Für diese Verbindung ist keine dauerhafte Zustimmung möglich.',
        failed: 'Die Einstellung konnte nicht geändert werden. Bitte versuch es erneut.',
      },
      rolePins: {
        notHeld: 'Diese Rolle hast du in diesem Modul nicht mehr.',
        failed: 'Die Rolle konnte nicht geändert werden. Bitte versuch es erneut.',
      },
      disconnect: 'Trennen',
      disconnectConfirm: '„{client}“ verliert sofort den Zugriff auf {workspace}. Um ihn wieder zu nutzen, verbinde ihn erneut aus dem Client heraus.',
      disconnected: '{client} getrennt.',
      disconnectFailed: 'Die Verbindung konnte nicht beendet werden. Bitte versuch es erneut.',
    },
    passkeys: {
      removeConfirm: 'Dieser Passkey wird entfernt. Das Gerät, das ihn nutzt, kann sich damit nicht mehr anmelden.',
      title: 'Passkeys',
      hint: 'Ein Passkey meldet dich mit deinem Gerät an — Fingerabdruck, Gesicht oder PIN. Nichts zu merken und nichts, was sich abfischen lässt.',
      none: 'Noch keine Passkeys.',
      add: 'Passkey hinzufügen',
      remove: 'Entfernen',
      unnamed: 'Passkey',
      lastUsed: 'Zuletzt verwendet am {when}',
      neverUsed: 'Noch nie verwendet',
      added: 'Passkey hinzugefügt.',
      removed: 'Passkey entfernt.',
      addFailed: 'Der Passkey konnte nicht hinzugefügt werden. Bitte erneut versuchen.',
      removeFailed: 'Der Passkey konnte nicht entfernt werden. Bitte erneut versuchen.',
      alreadyRegistered: 'Für dieses Gerät ist bereits ein Passkey hinterlegt.',
      lastMethod: 'Deine einzige Anmeldemethode kannst du nicht entfernen. Richte zuerst ein Passwort oder einen weiteren Passkey ein.',
      lostDevice: 'Ein Handy oder anderes Gerät verloren? Entferne seinen Passkey aus dieser Liste — erst das sperrt es aus deinem Konto aus.',
    },
    currentPassword: 'Aktuelles Passwort',
    phone: {
      title: 'Anmeldenummer',
      hint: 'Dein Konto meldet sich mit einem Passkey an. An diese Nummer gehen deine Einladungs- und Wiederherstellungslinks.',
    },
    email: {
      title: 'Anmeldeadresse',
      hint: 'Die Adresse, mit der du dich anmeldest. Eine Änderung ändert auch die Adresse, die deine Workspaces für dich anzeigen.',
      newLabel: 'Neue Adresse',
      submit: 'Änderung anfordern',
      pending: 'Warten auf Bestätigung an {email}. Folge dem Link, den wir dorthin geschickt haben.',
      cancel: 'Änderung abbrechen',
      cancelled: 'Die angeforderte Adressänderung wurde abgebrochen.',
      sent: 'Sieh im neuen Postfach nach. Bis du dem Link dort folgst, ändert sich nichts.',
      refused: 'Diese Adresse kann für dieses Konto nicht verwendet werden. Einer deiner Workspaces lässt nur Anmeldeadressen eigener Domains zu.',
      failed: 'Die Änderung konnte nicht angefordert werden. Bitte versuch es erneut.',
      ssoManaged: 'Deine Anmeldeadresse wird von deinem Identity Provider verwaltet.',
    },
    password: {
      title: 'Passwort',
      hint: 'Eine Passwortänderung meldet dich auf allen anderen Geräten ab.',
      newLabel: 'Neues Passwort',
      confirmLabel: 'Neues Passwort wiederholen',
      submit: 'Passwort ändern',
      changed: 'Dein Passwort wurde geändert. Andere Geräte wurden abgemeldet.',
      wrongCurrent: 'Das aktuelle Passwort ist nicht korrekt.',
      failed: 'Das Passwort konnte nicht geändert werden. Bitte versuch es erneut.',
      tooShort: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
      mismatch: 'Die beiden neuen Passwörter stimmen nicht überein.',
      ssoOnly: 'Dieses Konto meldet sich über deinen Identity Provider an und hat daher kein Passwort. Du kannst eines als Rückfallebene einrichten — wir schicken dir einen Link.',
      sendLink: 'Link zum Einrichten eines Passworts senden',
      linkSent: 'Falls für dieses Konto ein Passwort gesetzt werden kann, ist ein Link unterwegs.',
      linkFailed: 'Die Anfrage konnte nicht gesendet werden. Bitte versuch es erneut.',
    },
    confirmEmail: {
      title: 'Neue Adresse bestätigen',
      working: 'Wird bestätigt …',
      success: 'Deine Anmeldeadresse wurde geändert. Bitte melde dich mit der neuen Adresse erneut an.',
      goToLogin: 'Zur Anmeldung',
      backToAccount: 'Zurück zu Konto & Sicherheit',
      missingToken: 'Dieser Link ist unvollständig. Bitte öffne ihn direkt aus der E-Mail.',
      invalid: 'Dieser Bestätigungslink ist ungültig oder abgelaufen.',
      unavailable: 'Diese Änderung kann nicht mehr angewendet werden. Bitte fordere sie erneut an.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Änderung der Anmeldeadresse abbrechen',
      working: 'Wird abgebrochen…',
      success: 'Die Änderung wurde abgebrochen. Du meldest dich weiterhin mit deiner bisherigen Adresse an.',
      goToLogin: 'Zur Anmeldung',
      missingToken: 'Dieser Link ist unvollständig. Bitte öffne ihn direkt aus der E-Mail.',
      invalid: 'Dieser Link ist ungültig oder abgelaufen — es ist keine Änderung mehr offen.',
    },
    title: 'Konto & Sicherheit',
    identities: 'Verknüpfte Anmeldemethoden',
    noIdentities: 'Keine externen Anmeldemethoden verknüpft.',
    unlink: 'Entfernen',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Diese Anmeldemethode wird entfernt. Du kannst dich damit nicht mehr bei deinem Konto anmelden.',
    linkGoogle: 'Google verknüpfen',
    linkMicrosoft: 'Microsoft verknüpfen',
    linkApple: 'Apple verknüpfen',
    lastMethod: 'Du kannst deine einzige Anmeldemethode nicht entfernen. Lege zuerst ein Passwort fest.',
    linked: 'Anmeldemethode verknüpft.',
    unlinked: 'Anmeldemethode entfernt.',
    linkFailed: 'Verknüpfung fehlgeschlagen.',
  },
  workspace: {
    title: 'Workspace',
    subtitle: 'Wähle einen Tenant und ein Modul',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Dunkelmodus aktivieren',
    themeLight: 'Hellmodus aktivieren',
    welcomeTitle: 'Willkommen im Workspace',
    welcomeSubtitle:
      'Wähle deinen Mandanten und ein Anwendungsmodul, um zu starten.',
    availableModules: 'Verfügbare Module',
    comingSoonSection: 'Demnächst in lumi-HR',
    adminMode: 'Admin-Modus',
    aiUsage: {
      title: 'KI-Nutzung',
      pageIntro: 'Ob lumi in diesem Workspace verfügbar ist – und was die KI diesen Monat verbraucht hat.',
      loading: 'Nutzung wird geladen…',
      remaining: '{n} verbleibend',
      periodLabel: 'Abrechnungszeitraum',
      historyTitle: 'Abrechnungszeiträume',
      usedThisPeriod: 'In diesem Abrechnungszeitraum verbraucht',
      split: 'Inklusive {included} · Kontingent-Erweiterungen +{upgrades}',
      resetsOn: 'Wird am {date} zurückgesetzt',
      periodFrom: 'Abrechnungszeitraum ab {date}',
      nearLimit: 'Das KI-Kontingent dieses Abrechnungszeitraums ist fast aufgebraucht. Eine Kontingent-Erweiterung unter Abrechnung erhöht es sofort.',
      unlimited: 'Für diesen Workspace gilt kein KI-Kontingent.',
      ownKey: 'Dieser Workspace nutzt lumi mit einem eigenen KI-Anbieter-Key und hat deshalb kein KI-Kontingent.',
      noUsageYet: 'In diesem Abrechnungszeitraum noch keine KI-Nutzung.',
      upgradeLink: 'Kontingent unter Abrechnung erweitern',
      modules: {
        ats: 'Recruiting',
        time: 'Zeit',
        time_tracking: 'Zeit',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'lumi-Assistent',
        mcp: 'Externe KI-Agenten',
      },
    },
    active: 'Aktiv',
    systemAdmin: 'System-Admin',
    user: 'Benutzer',
    admin: 'Verwaltung',
    comingSoon: 'Demnächst',
    noTenants: 'Keine Tenants verfügbar',
    createViaCheckout: 'Workspace über den Checkout erstellen',
    loadFailed: 'Tenants konnten nicht geladen werden',
    retry: 'Erneut versuchen',
    logout: 'Abmelden',
    noAccess: 'Kein Zugriff',
  },
  support: {
    title: 'Support-Anfragen',
    myTickets: 'Meine Anfragen',
    myTicketsTitle: 'Meine Support-Anfragen',
    inbox: 'Posteingang',
    inboxTitle: 'Support-Posteingang',
    inboxSubtitle: 'Tickets aus den Tenants, die du betreust',
    ticket: 'Ticket',
    newTicket: 'Neue Support-Anfrage',
    newTicketTitle: 'Neue Support-Anfrage',
    newTicketIntro: 'Beschreib dein Anliegen und wir melden uns bei dir.',
    sent: 'Deine Anfrage wurde gesendet.',
    goToMyRequests: 'Zu meinen Support-Anfragen',
    subject: 'Betreff',
    subjectPlaceholder: 'Kurze Zusammenfassung',
    message: 'Nachricht',
    messagePlaceholder: 'Beschreib, was passiert ist…',
    consentLabel: 'Ich bestätige, dass meine Daten zur Bearbeitung dieser Anfrage verarbeitet werden',
    send: 'Senden',
    reply: 'Antworten',
    markComplete: 'Als erledigt markieren',
    reopen: 'Wieder öffnen',
    replyPlaceholder: 'Antwort schreiben…',
    escalate: 'Eskalieren',
    escalated: 'Eskaliert',
    deescalate: 'Eskalation zurücknehmen',
    deescalateBlocked: 'Für dieses Ticket besteht noch ein offener Support-Zugriff. Widerrufe ihn zuerst, dann kannst du die Eskalation zurücknehmen.',
    close: 'Schließen',
    statusLabel: 'Status',
    module: 'Modul',
    tenant: 'Tenant',
    requester: 'Anfragende Person',
    updated: 'Aktualisiert',
    backToTickets: 'Zurück zu meinen Anfragen',
    status: {
      open: 'Offen',
      in_progress: 'In Bearbeitung',
      answer: 'Beantwortet',
      closed: 'Geschlossen',
    },
    author: {
      user: 'Du',
      support: 'Support',
      systemAdmin: 'System-Admin',
    },
    empty: {
      myTitle: 'Noch keine Tickets',
      myBody: 'Sobald du ein Support-Ticket erstellst, erscheint es hier.',
      inboxTitle: 'Nichts zu betreuen',
      inboxBody: 'Du hast derzeit keine Support-Tickets in deinen Tenants.',
      notFoundTitle: 'Ticket nicht verfügbar',
      notFoundBody: 'Dieses Ticket konnte nicht geladen werden. Möglicherweise wurde es entfernt oder du hast keinen Zugriff.',
    },
  },
  notifications: {
    nav: 'Benachrichtigungen',
    title: 'Benachrichtigungen',
    subtitle: 'Dinge, die deine Aufmerksamkeit erfordern.',
    settings: 'Einstellungen',
    backToWorkspace: 'Zurück zum Workspace',
    area: 'Bereich',
    areaAll: 'Alle Bereiche',
    status: 'Status',
    statusAll: 'Alle',
    statusUnread: 'Ungelesen',
    statusRead: 'Gelesen',
    perPage: 'Pro Seite',
    markRead: 'Als gelesen markieren',
    markUnread: 'Als ungelesen markieren',
    markAllRead: 'Alle als gelesen markieren',
    loading: 'Wird geladen…',
    empty: 'Alles erledigt.',
    pageInfo: '{from}–{to} von {total}',
    prev: 'Zurück',
    next: 'Weiter',
    retentionHint: 'Benachrichtigungen werden 6 Monate lang gespeichert.',
    settingsTitle: 'Benachrichtigungen pro Bereich konfigurieren',
    settingsSubtitle: 'Lege fest, wie du pro Bereich benachrichtigt werden möchtest.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Ein paar Hinweise zu Sicherheit, Geld, Verträgen, deinem Workspace und gesetzlichen Fristen erreichen immer die Personen, die sie betreffen – sie erscheinen außerdem in der Glocke.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Dein Konto hat keine E-Mail-Adresse. Hinweise erreichen dich deshalb in der App (und als Push-Nachricht, wo du sie erlaubt hast). „{mailMode}“ wirkt darum wie „{inAppMode}“: Per E-Mail geht nichts raus.',
    mustReachStillReaches: 'Auch wenn du das hier ausschaltest, erreichen dich {list} weiterhin, wenn sie dich betreffen.',
    mandatoryReason: {
      billing: 'Kann nicht ausgeschaltet werden: Geld, das du schuldest, muss die verantwortliche Person erreichen.',
      legal: 'Kann nicht ausgeschaltet werden: Vertragsänderungen müssen dich laut AGB erreichen.',
    },
    mustReachFamily: {
      identity: 'sicherheitsrelevante Hinweise',
      money: 'Abrechnungshinweise',
      legal: 'Vertragshinweise',
      workspace: 'Hinweise zum Workspace-Status',
      privacy: 'Fristhinweise zum Datenschutz',
      participation: 'Anfragen an die Interessenvertretung',
    },
    backToList: 'Zurück zu den Benachrichtigungen',
    modeOff: 'Gar nicht',
    modeInApp: 'Nur in der App',
    modeMailInApp: 'E-Mail und in der App',
    saved: 'Gespeichert.',
    saveError: 'Konnte nicht gespeichert werden. Die Einstellung wurde zurückgesetzt.',
    openTarget: 'Zum verknüpften Objekt',
    opening: 'Wird geöffnet…',
    openFailed: 'Die Benachrichtigung konnte nicht geöffnet werden.',
    areas: {
      system: 'System',
      timecard: 'Zeit',
      ats: 'Recruiting',
      apprentice: 'Ausbildung',
      people: 'Personal',
      support: 'Support',
      postings: 'Stellenanzeigen',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Abrechnung',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Vertragsdokumente',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Meine Angaben speichern',
      later: 'Später',
      saved: 'Danke – deine Angaben sind gespeichert.',
      skip: {
        title: 'Angaben überspringen?',
        body: 'Solange du deine Angaben nicht ausfüllst, bleibt dein eigener Datensatz in Personal unbestätigt. Das heißt: Vertrags-, Urlaubs- oder Lohndaten können dort nicht erfasst werden, du kannst niemandem als Führungskraft zugeordnet werden und du erscheinst in Personal als „unbestätigt“. Du kannst das jederzeit nachholen – diese Erinnerung kommt morgen wieder.',
        fill: 'Jetzt ausfüllen',
        skip: 'Trotzdem überspringen',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'lumi einrichten',
      subtitle: 'Nichts davon ist Pflicht. Alles davon lohnt sich, wenn du so weit bist.',
      hide: 'Brauche ich nicht mehr',
      viewAll: 'Alles ansehen, was lumi kann',
      rareHeading: 'Seltener gebraucht',
      page: {
        title: 'Was lumi kann.',
        subtitle: 'Alles, was sich einrichten lässt. Das Wichtigste zuerst, der Rest, wenn du ihn brauchst.',
        tipsTitle: 'Tipps auf der Startseite',
        tipsShown: 'Das Panel steht oben auf deiner Startseite, bis du es nicht mehr brauchst.',
        tipsHidden: 'Du hast das Panel ausgeblendet. Hier holst du es zurück.',
        emptyTitle: 'Hier gibt es für dich nichts einzurichten.',
        emptyBody: 'Was sich einrichten lässt, richten die Verantwortlichen in deinem Team ein. Sprich sie an, wenn dir etwas fehlt.',
      },
      sections: {
        suite: 'Home',
        ats: 'Recruiting',
        time: 'Zeit',
        people: 'Personal',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Anmeldeseite gestalten', hint: 'Logo und Farben, damit dein Team sieht, dass es richtig ist.' },
        portal_design: { title: 'Karriereportal gestalten', hint: 'So sehen Bewerbende euer Unternehmen zuerst.' },
        email_templates: { title: 'E-Mail-Vorlagen', hint: 'Eingangsbestätigung, Einladung, Absage: einmal schreiben, immer verwenden.' },
        job_posting_settings: { title: 'Angaben für Stellenanzeigen', hint: 'Logo und Ansprechperson. Externe Stellenbörsen brauchen beides.' },
        work_time_models: { title: 'Arbeitszeitmodelle', hint: 'Wer wie viele Stunden an welchen Tagen arbeitet.' },
        company_holidays: { title: 'Betriebsferien', hint: 'Tage, an denen der Betrieb geschlossen ist.' },
        data_import: { title: 'Personen importieren', hint: 'Bestehende Listen übernehmen, statt alles abzutippen.' },
        company_profile: { title: 'Unternehmensprofil', hint: 'Adresse und Eckdaten, die lumi an vielen Stellen verwendet.' },
        org_units: { title: 'Organisationseinheiten', hint: 'Abteilungen und Standorte, nach denen sich vieles sortiert.' },
        payroll_handover: { title: 'Lohnübergabe (DATEV)', hint: 'lumi liefert die Stunden, dein Steuerbüro rechnet den Lohn.' },
        training_occupations: { title: 'Ausbildungsberufe', hint: 'Welche Berufe ihr ausbildet.' },
        workflows: { title: 'Workflows', hint: 'Eigene Schritte und Freigaben im Bewerbungsprozess.' },
        application_forms: { title: 'Bewerbungsformulare', hint: 'Welche Fragen Bewerbende beantworten.' },
        offer_templates: { title: 'Angebotsvorlagen', hint: 'Vertragsangebote mit Platzhaltern vorbereiten.' },
        custom_fields: { title: 'Eigene Felder', hint: 'Zusätzliche Angaben an Stellen und Bewerbungen.' },
        booking_types: { title: 'Buchungsarten', hint: 'Was neben Arbeitszeit gebucht werden kann.' },
        leave_types: { title: 'Abwesenheitsarten', hint: 'Urlaub, Krankheit und eure eigenen Arten.' },
        api_settings: { title: 'Schnittstelle (API)', hint: 'Zeiten per API an eigene Programme übergeben. Die Lohnübergabe steht unter Personal.' },
        time_clock: { title: 'Stempeluhr', hint: 'Im Browser eines Tablets im Betrieb öffnen: Jede Person meldet sich dort mit ihrem eigenen lumi-Zugang an und stempelt.' },
        sso: { title: 'Single Sign-on', hint: 'Anmeldung über euer Firmenkonto.' },
        onboarding_templates: { title: 'Onboarding-Vorlagen', hint: 'Checklisten für die ersten Tage neuer Kolleginnen und Kollegen.' },
        recruiting_options: { title: 'Optionslisten', hint: 'Anreden, Vertragsarten und Arbeitsorte, aus denen euer Team auswählt.' },
      },
    },
    greeting: { morning: 'Guten Morgen', day: 'Hallo', evening: 'Guten Abend' },
    // The date line under the greeting ("Montag, 21. September · KW 39",
    // workspace-start M2) replaced the static subtitle. Weekday + day/month come
    // from Intl; this key only supplies the week label.
    dateLine: { week: 'KW {n}' },
    open: 'Öffnen',
    recents: 'Zuletzt',
    recentKinds: { report: 'Wochenbericht', job: 'Stelle', application: 'Bewerbung' },
    moreActions: 'Weitere Aktionen',
    clockedInSince: 'Eingestempelt seit {time}',
    clockedOut: 'Ausgestempelt',
    clockOut: 'Ausstempeln',
    clockIn: 'Einstempeln',
    projectRunning: 'Projektzeit läuft',
    projectRunningSince: 'Seit {time}',
    startProject: 'Projekt starten',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Laut Vertrag buchst du keine Arbeitszeit, nur Projektzeit.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'Woran arbeitest du?',
      none: 'Ohne Projekt',
      noneSub: 'Zählt als „Nicht zugeordnet“',
      choose: 'Projekt und Tätigkeit wählen',
      fieldLabel: 'Woran arbeitest du? Gerade: {current}',
      runningWith: '{activity} · seit {time}',
      runningSince: 'Seit {time}',
      activityStep: 'Welche Tätigkeit?',
      back: 'Alle Projekte',
      defaultActivity: 'Standard',
      search: 'Projekt suchen',
      noMatch: 'Kein Projekt gefunden',
      close: 'Schließen',
    },
    provisioning: 'Wird eingerichtet – das kann eine Minute dauern.',
    preferences: 'Einstellungen',
    seeMyOrg: 'Meine Organisation',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Stellenanzeigen, Bewerbungen und die Pipeline – vom ersten Lebenslauf bis zum unterschriebenen Vertrag.',
        time_tracking: 'Kommen und Gehen, Arbeitszeitkonten, Abwesenheiten und Überstunden – bereit für die Arbeitszeiterfassung.',
        apprenticeship: 'Digitale Berichtshefte, Ausbildungspläne und Beurteilungen für alle Azubis im Betrieb.',
      },
      heading: 'Weitere Module',
    },
    // A panel with no content of its own (#364 F12). Every homebase panel says
    // one of these instead of rendering as a blank box: `empty` = the module
    // answered and has nothing yet, `unavailable` = it did not answer at all
    // (unreachable, or not readable for this member) — never conflated.
    empty: 'Hier ist noch nichts – öffne das Modul, um loszulegen.',
    unavailable: 'Kann gerade nicht geladen werden.',

    goToModule: 'Zu {module}', expand: '{module} ausklappen', collapse: '{module} einklappen',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    people: { selfService: 'Meine Daten' },
    myDocuments: {
      title: 'Meine Dokumente',
      downloadFailed: 'Download fehlgeschlagen – bitte später erneut versuchen.',
      showAll: 'Alle anzeigen ({count})',
      showLess: 'Weniger anzeigen',
      handIn: 'Dokument einreichen',
      empty: 'Noch nichts da. Du kannst ein Zeugnis, eine Bescheinigung, ein Attest oder eine Ausweiskopie für deine Akte einreichen.',
      kindLabel: 'Was ist es?',
      fileLabel: 'Datei – auswählen oder fotografieren',
      send: 'Senden',
      cancel: 'Abbrechen',
      handedIn: 'Eingereicht am {date} · wartet auf HR',
      accepted: 'Eingereicht am {date} · übernommen',
      sentBack: 'Zurückgegeben am {date}: „{reason}“',
      handInAgain: 'Erneut einreichen',
      dismiss: 'Ausblenden',
      error: {
        file_refused: 'Diese Datei konnte nicht angenommen werden – bitte versuche eine andere Datei.',
        file_too_large: 'Diese Datei ist zu groß – das Limit liegt bei 25 MB.',
        file_empty: 'Diese Datei ist leer – bitte wähle eine andere Datei.',
        file_missing: 'Bitte wähle zuerst eine Datei aus.',
        quota_exceeded: 'Deine Akte hat ihren Speicherplatz erreicht – bitte wende dich an HR.',
        invalid_category: 'Bitte wähle, um welche Art von Dokument es sich handelt.',
        not_possible: 'Einreichen ist gerade nicht möglich – bitte wende dich an HR.',
        generic: 'Einreichen fehlgeschlagen – bitte versuche es später erneut.',
        scan_unavailable: 'Die Datei konnte gerade nicht geprüft werden. Bitte versuche es gleich noch einmal.',
      },
      category: {
        contract: 'Arbeitsvertrag',
        contract_amendment: 'Vertragsänderung',
        certificate: 'Zeugnis',
        attestation: 'Bescheinigung',
        payslip: 'Lohnabrechnung',
        health_certificate: 'Krankmeldung / ärztliches Attest',
        identification: 'Ausweisdokument',
        other: 'Sonstiges',
      },
    },
    admin: {
      users: 'Benutzer',
      usersMoved: {
        title: 'Die Benutzerverwaltung ist in Personal umgezogen',
        redirecting: 'Personal wird geöffnet …',
        noPeople: 'Wer Zugang zu diesem Workspace hat, wird an der jeweiligen Person in Personal verwaltet. Personal ist für dich hier nicht verfügbar – wende dich an die Inhaberin oder den Inhaber des Workspace.',
      },
    },
    verwaltung: { heading: 'Verwaltung' },
    nav: { home: 'Dashboard', billing: 'Abrechnung', logout: 'Abmelden', language: 'Sprache', administration: 'Administration', sso: 'Single Sign-On', audit: 'Audit-Log', supportAccess: 'Support-Zugriff', aiUsage: 'KI-Nutzung', dataProcessing: 'Datenverarbeitung', dataRequests: 'Betroffenenanfragen', legalNotices: 'Rechtliche Hinweise', statutoryRules: 'Gesetzliche Vorgaben', trainingOccupations: 'Ausbildungsberufe', externalAgents: 'Externe KI-Agenten', setup: 'Einrichten' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Diese Woche',
      hoursUnit: 'Std.',
      balance: 'Zeitkonto, Stand {date}: {balance}',
      balanceHint: 'Gearbeitete minus geschuldete Stunden bis zu diesem Tag.',
      noTarget: 'Keine Wochenstunden hinterlegt.',
      trustBased: 'Du arbeitest in Vertrauensarbeitszeit – Beginn und Ende erfasst du, ein Soll und ein Zeitkonto gibt es für dich nicht.',
      projectsMore: 'und {n} weitere',
      days: 'Wochentage',
    },
    // The Heute row (workspace-start M2): up to four tiles above the module
    // bands. `kind.*` titles the date tile by what the date actually is.
    heute: {
      clock: 'Stempeluhr',
      attention: 'Braucht mich',
      news: 'Neu',
      leaveRemaining: 'Urlaub übrig',
      days: 'Tag | Tage',
      // 'Interview' matches the ATS module's own German vocabulary
      // (backoffice-ui's interview tabs), not the more formal
      // 'Vorstellungsgespräch' — byte-identical to the English default,
      // allow-listed in scripts/i18n-untranslated-allow.json on purpose.
      kind: { interview: 'Interview', leave: 'Abwesenheiten', holiday: 'Feiertag', exam: 'Prüfung', station: 'Stationswechsel' },
    },
    facts: {
      ats: { total_jobs: 'Stellen', total_applications: 'Bewerbungen', open_tasks: 'Offene Aufgaben', new_applicants: 'Neue Bewerber', create_job: 'Stelle ausschreiben', add_application: 'Bewerbung hinzufügen', create_task: 'Aufgabe erstellen', pipeline: 'Pipeline', pipeline_closed: '{n} abgeschlossen', stage_other: 'Sonstige' },
      time: { week_hours: 'Stunden diese Woche', today_hours: 'Stunden heute', timesheet: 'Meine Zeiterfassung', request_leave: 'Urlaub beantragen', approvals: 'Freigaben', team: 'Team', pending_approvals: 'Offene Freigaben', leave_remaining: 'Urlaub übrig' },
      // 'badges' is 'Skills' — Azubi's own German vocabulary (apprentice-api's
      // user-dashboard, see 'Skill-Wand' two entries below), not 'Abzeichen';
      // byte-identical to the English default, allow-listed on purpose.
      apprentice: { waiting: 'Zu prüfen', active: 'Azubis', overdue: 'Fehlende Wochen', this_week: 'Diese Woche', badges: 'Skills', write: 'Woche eintragen', skills: 'Skill-Wand', review: 'Berichte prüfen', onboard: 'Azubi anlegen', reports: 'Berichtshefte', report_approved: 'Abgenommen', report_submitted: 'Zu prüfen', report_rejected: 'Zurückgegeben', report_missing: 'Fehlt' },
    },
  },
  preferences: {
    appearance: 'Darstellung',
    theme: 'Design',
    themeHint: 'Helle oder dunkle Oberfläche.',
    language: 'Sprache',
    languageHint: 'Die Sprache im gesamten Workspace.',
    attributions: 'Open-Data-Nachweise',
    placesCredit: 'Ortsdaten © {source}, lizenziert unter {licence}.',
    bankCodesCredit: "Bankleitzahlen: Quelle {bundesbank}; österreichische Bankleitzahlen © {oenb}, lizenziert unter {licence}; schweizerische und liechtensteinische © {six}.",
    healthInsurersCredit: "Krankenkassen: Stammdatendatei, herausgegeben vom {gkv}.",
  },
  onboarding: {
    actions: { add: 'Hinzufügen', back: 'Zurück', next: 'Weiter', remove: 'Entfernen' },
    modules: {
      ats: 'Recruiting',
      time_tracking: 'Zeit',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence
      // (a translation moves the words, never the rule).
      eyebrow: 'Willkommen bei lumi',
      title: 'Schön, dass du',
      titleMark: 'da bist.',
      subtitle: 'Wie möchtest du starten? Du kannst jederzeit wechseln.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Raus aus der Demo',
      titleDemo: 'Genug ausprobiert.',
      titleDemoMark: 'Jetzt echt.',
      subtitleDemo: 'Mit der geführten Einrichtung bleibt die Demo-Firma da, bis du abschließt.',
      reassure: 'Unsicher? Starte mit der Demo – zur echten Einrichtung wechselst du jederzeit.',
      seedFailed: 'Die Demo-Daten konnten nicht vollständig vorbereitet werden. Bitte versuch es erneut.',
      seedFailedNotEmpty:
        'Die Demo braucht leere Module, aber eines deiner Module enthält bereits Daten. Entferne sie zuerst oder wähle stattdessen „Suite einrichten“.',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'Die Einrichtung kann erst abgeschlossen werden, wenn der Auftragsverarbeitungsvertrag (AVV) akzeptiert ist. Akzeptiere ihn hier, dann geht es direkt im Einrichtungsassistenten weiter.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Zurück zur Demo',
      demo: {
        eyebrow: 'Ausprobieren',
        title: 'Mit Demo-Daten erkunden',
        body: 'Wir füllen deine Module mit einer stimmigen, fiktiven Firma. Klick dich durch alles, ohne etwas kaputt zu machen.',
        modulesHint: 'Gebuchte Module sind immer dabei.',
        cta: 'Demo erkunden',
      },
      guided: {
        eyebrow: 'Einrichten',
        title: 'Führ mich durch die Einrichtung',
        body: 'Schritt für Schritt zu deiner echten Suite. Pausieren, überspringen oder doch erst zur Demo – alles geht.',
        bodyDemo: 'Schritt für Schritt zu deiner echten Suite. Schließt du das Fenster, bist du wieder in der Demo.',
        pointSaved: 'Dein Zwischenstand wird gespeichert',
        pointOptional: 'Jeder Schritt ist optional',
        cta: 'Führ mich durch',
      },
      empty: {
        eyebrow: 'Selbst machen',
        titleFresh: 'Leer starten',
        titleDemo: 'Demo verwerfen und leer starten',
        bodyFresh: 'Ein freies Feld. Du richtest alles nach und nach selbst ein, genau in deinem Tempo.',
        bodyDemo: 'Die Demo-Firma wird gelöscht, du startest auf einer leeren Basis.',
        warnDemo: 'Das passiert sofort und lässt sich nicht rückgängig machen.',
        cta: 'Leer starten',
      },
    },
    exitGate: {
      title: 'Bevor du die Demo verlässt',
      intro: 'Das hat dein Workspace gebucht, und so steht es um deine Testphase. Buche ein Modul jetzt oder später unter Abrechnung – einrichten kannst du so oder so.',
      booked: { title: 'Gebucht' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Kolleg:innen, die du in die Demo eingeladen hast',
        lead: 'Diese Kolleg:innen verlieren ihren Zugang, wenn die Demo endet:',
        fallback: 'Kolleg:innen, die du in die Demo eingeladen hast, verlieren ihren Zugang, wenn sie endet.',
        people: 'Dein echtes Team lädst du über Personal ein, sobald dein Workspace eingerichtet ist.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: '{module} wird eingerichtet …',
        booked: '{module} ist gebucht und hat einen eigenen Abschnitt im Einrichtungsassistenten.',
        bookedPending: '{module} ist gebucht. Der Abschnitt im Einrichtungsassistenten erscheint, sobald das Modul bereit ist.',
      },
      noManage: 'Nur die Inhaberin oder der Inhaber des Workspace, eine Abrechnungsverantwortliche oder ein Workspace-Admin kann Module buchen. Du kannst trotzdem ohne Buchung fortfahren.',
      enforcement: 'In diesem Workspace steht eine Zahlung aus. Buchungen pausieren, bis sie beglichen ist – die Einrichtung deiner Suite nicht.',
      factsUnavailable: 'Wir konnten deine Buchung gerade nicht laden. Du kannst trotzdem fortfahren; alles steht auf der Abrechnungsseite.',
      trial: {
        title: 'Deine Testphase',
        range: 'Deine Testphase hat am {start} begonnen und endet am {end}.',
        endOnly: 'Deine Testphase endet am {end}.',
        rangeFree: 'Kostenlos von {start} bis {end}.',
        endOnlyFree: 'Kostenlos bis {end}.',
        charge: 'Ab dem {end} werden {amount} pro Monat für deine Buchung berechnet, jeweils zu Beginn eines Abrechnungsmonats.',
        chargeNoTotal: 'Ab dem {end} wird deine Buchung monatlich berechnet, jeweils zu Beginn eines Abrechnungsmonats.',
        firstCharge: 'Die erste Abbuchung erfolgt am {date}.',
        demoCounted: 'Die Zeit in der Demo hat zu deiner Testphase gezählt.',
        over: 'Deine Testphase ist beendet, deine Buchung wird monatlich abgerechnet.',
        monthly: 'Das sind {amount} pro Monat.',
        nextCharge: 'Die nächste Abbuchung erfolgt am {date}.',
      },
      continue: 'Weiter zur Einrichtung',
    },
    avv: {
      modalTitle: 'Auftragsverarbeitungsvertrag (AVV) akzeptieren',
      modalBody:
        'Wenn du deine Suite mit echten Daten einrichtest, verarbeitet lumi in deinem Auftrag personenbezogene Daten. Bitte lies und akzeptiere zunächst unseren aktuellen Auftragsverarbeitungsvertrag (AVV).',
      modalLinkText: 'Vollständigen AVV lesen',
      modalCheckboxLabel: 'Ich habe den aktuellen AVV gelesen und akzeptiere ihn.',
      modalCancel: 'Noch nicht',
      modalAccept: 'Akzeptieren und fortfahren',
    },
    preparing: {
      first: {
        title: 'Deine Demo wird vorbereitet.',
        body: 'Wir legen eine stimmige, fiktive Firma über alle deine Module hinweg an. Das dauert nur einen Moment.',
      },
      reset: {
        title: 'Deine Demo wird zurückgesetzt.',
        body: 'Wir leeren die Demo-Firma und bauen sie von Grund auf neu auf. Dein Workspace und deine Kolleg:innen bleiben unberührt. Das dauert nur einen Moment.',
      },
      stuck: {
        note: 'Das dauert länger als gewöhnlich.',
        cta: 'Stattdessen manuell einrichten',
      },
    },
    nonAdmin: {
      title: 'Fast',
      titleMark: 'geschafft.',
      body: 'Deine Administratorin oder dein Administrator richtet die Suite noch ein. Sobald das erledigt ist, kommst du hier direkt rein.',
    },
    wizard: {
      title: 'Suite einrichten',
      subtitle: 'Alles hier ist optional und dein Zwischenstand wird gespeichert. Richte ein, was du möchtest, schließe die Einrichtung ab oder kehre zur Demo zurück, indem du das Fenster schließt.',
      subtitleCommitting: 'Deine Einrichtung wird übernommen. Klappt ein Schritt nicht, kannst du ihn überspringen und später in den Einstellungen nachholen.',
      crossRef: 'Wird in {modules} verwendet — später in {owner} änderbar.',
      crossRefOwnerDefault: 'Personal',
      recovery: '„{step}“ konnte nicht übernommen werden. Prüfe deine Angaben dort und schließe erneut ab.',
      details: {
        step: 'Deine Angaben',
        title: 'Deine Angaben',
        subtitle: 'Dein eigener Datensatz in Personal. Prüfe deinen Namen – mit dem Speichern bestätigst du deinen Datensatz.',
        loading: 'Dein Datensatz wird geladen …',
        confirmed: 'Dein Datensatz ist als {name} bestätigt. Ändern kannst du ihn später in Personal.',
        unavailable: 'Dein Datensatz konnte gerade nicht geladen werden. Du kannst ihn später in Personal bestätigen.',
        firstName: 'Vorname',
        lastName: 'Nachname',
        required: 'Gib deinen Vor- und Nachnamen ein.',
        hq: {
          title: 'Euer Hauptsitz',
          why: 'Ganz ohne Standort geht es leider nicht: Lumi braucht euren Hauptsitz als ersten Standort, zum Beispiel für eure Stellen.',
          street: 'Straße',
          postalCode: 'PLZ',
          city: 'Ort',
          country: 'Land',
          countryNone: 'Kein Land ausgewählt',
          required: 'Gib Straße, PLZ, Ort und Land eures Hauptsitzes ein.',
        },
      },
      general: {
        title: 'Allgemein',
        company: {
          title: 'Firmenprofil',
        },
        name: {
          label: 'Firmenname',
          hint: 'Aus dem Checkout vorausgefüllt — bei Bedarf anpassen. Erforderlich.',
          required: 'Unternehmensname ist erforderlich.',
        },
        profile: {
          industry: 'Branche',
          employeeCountRange: 'Unternehmensgröße',
          employeeCountPlaceholder: 'z. B. 50–200',
          foundedYear: 'Gegründet',
          foundedYearPlaceholder: 'z. B. 2010',
          legalForm: 'Rechtsform',
          websiteUrl: 'Website',
        },
        place: {
          hint: 'Wähle eine Stadt aus der Liste als Namen für den Standort – oder tippe einen eigenen Namen und bestätige mit Enter oder +.',
        },
        org: {
          title: 'Organisationsstruktur',
          subtitle: 'Abteilungen, Standorte und Kostenstellen, denen deine Mitarbeitenden angehören.',
          departments: 'Abteilungen',
          locations: 'Standorte',
          costCenters: 'Kostenstellen',
          empty: 'Noch keine',
          addDepartment: 'Neue Abteilung',
          addLocation: 'Neuer Standort, z. B. Berlin',
          addCostCenter: 'Neue Kostenstelle',
        },
      },
      finish: {
        cta: 'Einrichtung abschließen',
        step: 'Abschluss',
        title: 'Einrichtung abschließen',
        body: 'Beim Abschließen werden deine Angaben übernommen. Du kannst später in jedem Modul alles ändern.',
        nextTitle: 'Als Nächstes: Team einladen',
        nextBody: 'Lade nach der Einrichtung im Admin-Bereich die ersten Nutzer ein und weise ihre Rollen zu.',
        demoWarning: 'Beim Abschließen werden das Demo-Unternehmen und alle währenddessen eingeladenen Nutzer gelöscht.',
      },
      sections: {
        ats: {
          title: 'Recruiting',
          subtitle: 'Lege fest, wie Bewerbungen und Recruiting-E-Mails funktionieren.',
          fields: {
            fromName: { label: 'Absendername', hint: 'Wird in E-Mails an Kandidat:innen angezeigt.' },
            signature: { label: 'E-Mail-Signatur', hint: 'Wird an ausgehende Kandidaten-E-Mails angehängt.' },
          },
          jobPosting: {
            title: 'Stellenanzeigen',
            hint: 'Bewerbungskontakt und Logo, die auf externen Stellenanzeigen erscheinen (optional — du kannst das auch später einrichten).',
            contactName: 'Kontaktname',
            contactEmail: 'Kontakt-E-Mail',
            logo: 'Anzeigen-Logo',
            uploadLogo: 'Logo hochladen',
            removeLogo: 'Entfernen',
            rePick: 'Dein Logo wurde noch nicht hochgeladen — bitte wähle es erneut.',
            contactEmailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
          },
          workflow: {
            title: 'Bewerbungsprozess',
            participantsQuestion: 'Wer ist bei Stellenanzeigen und Bewerbungen beteiligt?',
            worksCouncil: 'Betriebsrat',
            sbv: 'Schwerbehindertenvertretung',
            legalSignOff: 'Rechtsabteilung – gibt Stellenanzeigen vor der Veröffentlichung frei',
            assessmentCentreQuestion: 'Nutzt ihr Assessment-Center?',
            assessmentCentre: 'Ja, wir nutzen Assessment-Center',
            hint: 'Du kannst den Prozess später jederzeit im ATS bearbeiten und anpassen.',
          },
        },
        time_tracking: {
          title: 'Zeit',
          subtitle: 'Buchungsarten und Regeln zur Arbeitszeit.',
          fields: {
            bookingTypes: { label: 'Buchungsarten', hint: 'Füge die Buchungsarten hinzu, die du nutzt.', placeholder: 'z. B. Arbeit' },
          },
          companyHolidays: {
            title: 'Betriebsferien',
            hint: 'Tage, an denen der Betrieb geschlossen ist – zum Beispiel ein halber Tag an Heiligabend und Silvester. An diesen Tagen fallen keine Sollstunden an. Je Eintrag legst du fest, ob er vom Urlaub abgezogen wird; ändern kannst du das später in den Einstellungen von Zeit.',
            empty: 'Noch keine Betriebsferien eingetragen.',
            suggestions: 'Vorschläge:',
            christmasEve: 'Heiligabend',
            newYearsEve: 'Silvester',
            name: 'Bezeichnung',
            namePlaceholder: 'z. B. Zwischen den Jahren',
            from: 'Von',
            to: 'Bis (optional)',
            halfDay: 'Halber Tag',
            yearly: 'Jedes Jahr',
            deductsFromLeave: 'Vom Urlaub abziehen',
            rangeReversed: 'Das Enddatum liegt vor dem Startdatum.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Ausbildungsberufe.',
          fields: {
            professions: { label: 'Ausbildungsberufe', hint: 'Die Ausbildungsberufe, in denen du ausbildest.', placeholder: 'z. B. Fachinformatiker/in' },
          },
        },
        people: {
          title: 'Personal',
          subtitle: 'Gemeinsames Vokabular für die gesamte Suite.',
          fields: {
            salutations: { label: 'Anreden', hint: 'Ergänze Anreden zusätzlich zum Standard.', placeholder: 'z. B. Divers' },
            contractTypes: { label: 'Vertragsarten', hint: 'Ergänze Vertragsarten zusätzlich zum Standard.', placeholder: 'z. B. Werkstudent' },
            workTimeModels: { label: 'Arbeitszeitmodelle', hint: 'Ergänze Modelle zusätzlich zum Standard.', placeholder: 'z. B. Jobsharing' },
            workLocationTypes: { label: 'Arbeitsorte', hint: 'Ergänze Arbeitsorte zusätzlich zum Standard.', placeholder: 'z. B. Außendienst' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Demo wird entfernt…',
        body: 'Das Demo-Unternehmen wird entfernt, damit deine echte Einrichtung sauber startet.',
      },
      applying: {
        title: 'Deine Suite wird eingerichtet…',
        body: 'Deine Angaben werden übernommen. Das dauert nur einen Moment.',
      },
      steps: {
        company: 'Firmenprofil',
      },
      error: 'Beim Anwenden deiner Einrichtung ist etwas schiefgelaufen.',
      retry: 'Erneut versuchen',
      backToSetup: 'Zurück zur Einrichtung',
      skipStep: 'Ohne diesen Schritt abschließen',
      skipped: 'Übersprungen: {steps}. Das kannst du jederzeit in den Einstellungen nachholen.',
      resume: 'Einrichtung fortsetzen',
      stalled: 'Das dauert länger als erwartet.',
      wipeFailed: 'Die Demo konnte nicht entfernt werden. Versuche es erneut.',
      logoMissing: 'Dein Logo wurde nicht hochgeladen (beim Neuladen verloren) — du kannst es später in den Stellenanzeigen-Einstellungen hinzufügen.',
      workflowFailed: 'Deine Prozesskette konnte nicht erzeugt werden, deshalb startet dein Workspace mit der Standardkette. Alles andere wurde übernommen — öffne die Workflow-Einstellungen im Recruiting, um den Generator erneut zu starten.',
      workflowDrafted: 'Dein Recruiting-Prozess wurde als Entwurf gespeichert, weil {roles} aktuell nicht besetzt ist. Öffne die Workflow-Einstellungen im Recruiting, um ihn zu aktivieren, sobald die Rolle besetzt ist.',
      workflowRoles: {
        ats_works_council: 'der Betriebsrat',
        ats_sbv: 'die Schwerbehindertenvertretung',
        ats_legal: 'die Rechtsabteilung',
      },
      continue: 'Weiter zum Arbeitsbereich',
    },
  },
  tenants: {
    switcherLabel: 'Workspace wechseln',
    supportAccessBadge: 'Support',
    supportAccessUntil: 'Befristeter Support-Zugriff bis {until}',
    supportAccessBanner: 'Der lumi-Support hat derzeit befristeten Zugriff auf diesen Workspace.',
    supportAccessReview: 'Prüfen',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Was eine Löschung blockiert',
      intro: 'Personaldokumente ohne Aufbewahrungsfrist werden unbefristet aufbewahrt: Niemand hat entschieden, wie lange sie aufzubewahren sind, und ein unentschiedenes Dokument wird nie automatisch gelöscht. Hier siehst Du sie, damit die Fristen gesetzt werden können.',
      sensitivePlaceholder: 'Sensibles Dokument',
      categories: {
        contract: 'Vertrag',
        contract_amendment: 'Vertragsänderung',
        certificate: 'Zeugnis',
        attestation: 'Bescheinigung',
        warning: 'Abmahnung',
        other: 'Sonstiges Dokument',
      },
      outcomes: {
        refused: 'Löschung abgelehnt',
        partial: 'Teilweise gelöscht',
      },
      list: {
        title: 'Dokumente ohne Aufbewahrungsfrist',
        fixHint: 'Die ältesten stehen oben. Setze im Personaldokument eine Aufbewahrungsfrist, dann verschwindet es aus dieser Liste.',
        loading: 'Dokumente werden geladen…',
        loadError: 'Die Liste konnte nicht geladen werden. Bitte versuche es erneut – das heißt nicht „nichts gefunden“.',
        empty: 'Alle Dokumente in diesem Workspace haben eine Aufbewahrungsfrist.',
        uploadedLabel: 'Hochgeladen',
        truncated: 'Es werden nur die {count} ältesten Dokumente angezeigt. Weitere warten auf eine Aufbewahrungsfrist.',
      },
    },
    myData: {
      title: 'Meine Daten',
      intro: 'Hier kannst Du erfragen, welche Daten dieser Workspace über Dich gespeichert hat, eine Korrektur verlangen oder die Löschung beantragen. Jede Anfrage wird erfasst und von den Verantwortlichen für den Datenschutz in diesem Workspace beantwortet, und Du kannst sie hier verfolgen.',
      requests: {
        title: 'Meine Anfragen',
        loading: 'Deine Anfragen werden geladen …',
        loadError: 'Deine Anfragen konnten nicht geladen werden. Du kannst unten trotzdem eine Anfrage stellen.',
        empty: 'Du hast noch keine Anfrage gestellt.',
        filedLabel: 'Gestellt',
        dueLabel: 'Antwort fällig',
        outcomeLabel: 'Ergebnis',
        awaitingRelease: 'Kopie wird geprüft',
      },
      kinds: {
        access: 'Kopie meiner Daten',
        rectification: 'Korrektur',
        erasure: 'Löschung',
      },
      statuses: {
        received: 'Eingegangen',
        verifying: 'Identität wird geprüft',
        in_progress: 'In Bearbeitung',
        awaiting_subject: 'Wartet auf Deine Antwort',
        completed: 'Abgeschlossen',
        refused: 'Abgelehnt',
        withdrawn: 'Zurückgezogen',
      },
      outcomes: {
        erased: 'Daten gelöscht',
        suppressed: 'Daten gelöscht, Minimaleintrag bleibt',
        refused: 'Abgelehnt',
        partial: 'Teilweise erledigt',
        answered: 'Beantwortet',
      },
      actions: {
        access: {
          title: 'Kopie meiner Daten anfordern',
          body: 'Du kannst eine Kopie der Daten anfordern, die dieser Workspace über Dich gespeichert hat. Das ist kein sofortiger Download: Die Kopie wird erst zusammengestellt, und Du erfährst es, sobald sie bereitliegt.',
          where: 'Eine fertige Kopie wird nie als E-Mail-Anhang verschickt. Du bekommst eine E-Mail, meldest Dich in Deinem lumi-HR-Konto an und lädst sie dort herunter.',
          cta: 'Kopie anfordern',
          detailLabel: 'Ergänzung (optional)',
          detailHint: 'Zum Beispiel, wenn Du nur einen Teil Deiner Daten möchtest.',
        },
        rectification: {
          title: 'Korrektur beantragen',
          body: 'Wenn etwas, das dieser Workspace über Dich gespeichert hat, falsch oder veraltet ist, kannst Du eine Korrektur verlangen.',
          cta: 'Korrektur beantragen',
          detailLabel: 'Was ist falsch, und was ist richtig?',
          detailHint: 'Beschreibe die Daten so genau wie möglich, damit sie gefunden und geprüft werden können.',
          selfTitle: 'Einiges kannst Du selbst ändern',
          selfFields: 'Name und Anrede, Geschlecht, Kontakt-E-Mail, Telefonnummer, Adresse, Staatsangehörigkeit, Familienstand und Sprache änderst Du selbst in Deinem Profil.',
          selfLink: 'Mein Profil öffnen',
          askBody: 'Für alles andere – Geburtsdatum, Personalnummer, Vertrags-, Lohn- oder Steuerdaten, Deine Dokumente – nutze die Anfrage unten.',
        },
        erasure: {
          title: 'Löschung meiner Daten beantragen',
          body: 'Du kannst beantragen, dass dieser Workspace die Daten löscht, die er über Dich gespeichert hat.',
          cta: 'Löschung beantragen',
          confirm: 'Deine Anfrage wird von den Verantwortlichen in diesem Workspace geprüft. Daten, die gesetzlich aufbewahrt werden müssen oder für Dein Arbeitsverhältnis noch gebraucht werden, können nicht gelöscht werden. Du erfährst, was gelöscht wurde und was bleibt.',
          detailLabel: 'Ergänzung (optional)',
          detailHint: 'Zum Beispiel, welche Daten Du meinst, wenn es nicht alle sind.',
        },
      },
      form: {
        submit: 'Anfrage senden',
        submitting: 'Wird gesendet …',
        cancel: 'Abbrechen',
        success: 'Deine Anfrage ist erfasst. Du findest sie oben unter „Meine Anfragen“.',
        errorGeneric: 'Deine Anfrage konnte nicht gesendet werden. Es wurde nichts erfasst – bitte versuche es erneut.',
        errorRateLimit: 'Du hast in kurzer Zeit mehrere Anfragen gesendet. Bitte versuche es später erneut.',
      },
    },
    export: {
      title: 'Diesen Workspace exportieren',
      intro: 'Du kannst jederzeit eine vollständige Kopie von allem herunterladen, was dieser Workspace speichert — maschinenlesbar und ohne uns zu fragen.',
      contents: {
        title: 'Was in dieser Datei steckt',
        body: 'Das Archiv enthält die Daten aller Personen im Klartext und dazu die aktiven Zugangsschlüssel dieses Workspace: den KI-Schlüssel, Kalenderlinks samt Tokens und die Zugangsdaten angebundener Anbieter. Das Archiv enthält außerdem für Personal, Recruiting und Zeit je ein HR Open Standards (HR-JSON)-Dokument — das gemeinsame Format, falls du zu einem anderen Anbieter wechselst.',
        handling: 'Bewahre es so sorgfältig auf wie diese Schlüssel selbst. Wer die Datei und das Passwort hat, hat alles darin.',
      },
      roleRequired: {
        title: 'Für diesen Export ist die Rolle „Datenschutz“ nötig',
        body: 'Das Archiv enthält jede Datei, die in diesem Workspace liegt — darunter Gehaltsabrechnungen, Atteste und Ausweisdokumente — neben den personenbezogenen Daten aller und den aktiven Zugangsschlüsseln dieses Workspace.',
        hint: 'Diesen Workspace zu besitzen reicht dafür nicht mehr: Wer den Export startet, braucht zusätzlich die Rolle „Datenschutz“. Sie wird zusammen mit den übrigen Suite-Rollen in der Benutzerverwaltung vergeben — auch an Dich.',
      },
      start: {
        title: 'Export starten',
        body: 'Wähle ein Passwort. Das Archiv wird damit verschlüsselt, und nur damit lässt es sich öffnen.',
        passphraseWarning: 'Wir speichern dein Passwort nicht und können es nicht wiederherstellen. Wenn du es verlierst, lässt sich das Archiv nicht mehr öffnen — es gibt kein Zurücksetzen.',
        passphraseLabel: 'Passwort',
        passphraseHint: 'Mindestens {min} Zeichen. Nimm etwas Langes, das du sicher aufbewahren kannst.',
        confirmLabel: 'Passwort wiederholen',
        submit: 'Export starten',
        submitting: 'Wird gestartet…',
        success: 'Der Export wurde gestartet. Er wird im Hintergrund erstellt und erscheint unten, sobald er fertig ist.',
        errorTooShort: 'Das Passwort braucht mindestens {min} Zeichen.',
        errorMismatch: 'Die beiden Passwörter stimmen nicht überein.',
        errorAlreadyRunning: 'Für diesen Workspace läuft bereits ein Export. Warte, bis er fertig ist, bevor du einen neuen startest.',
        errorTooMany: 'Dieser Workspace hat vorerst die maximale Anzahl an Exporten gestartet. Bitte versuche es später erneut.',
        errorGeneric: 'Wir konnten nicht bestätigen, dass der Export gestartet wurde. Schau in der Liste unten nach, bevor du einen neuen startest.',
      },
      list: {
        title: 'Exporte dieses Workspace',
        loading: 'Exporte werden geladen…',
        loadError: 'Die Exporte konnten nicht geladen werden.',
        empty: 'Dieser Workspace wurde noch nicht exportiert.',
        linkHint: 'Ein Downloadlink ist nur kurz gültig. Wenn er nicht mehr funktioniert, nutze die Schaltfläche einfach erneut.',
        retentionHint: 'Jedes Archiv wird automatisch gelöscht, sobald es abläuft — das Datum steht daneben.',
        startedLabel: 'Gestartet',
        expiresLabel: 'Verfügbar bis',
        download: 'Herunterladen',
        preparing: 'Wird vorbereitet…',
        downloadError: 'Der Download konnte nicht vorbereitet werden. Möglicherweise ist das Archiv nicht mehr da.',
        gone: 'Das Archiv wurde gelöscht. Starte einen neuen Export, wenn du eine weitere Kopie brauchst.',
        failedHint: 'Dieser Export wurde nicht fertig. Du kannst einen neuen starten.',
        runningHint: 'Dieser Export wird noch erstellt.',
      },
      statuses: {
        requested: 'Angefordert',
        exporting: 'Wird erstellt',
        exported: 'Fertig',
        failed: 'Fehlgeschlagen',
        expired: 'Gelöscht',
      },
    },
    settingsPanel: {
      title: 'Datenverarbeitung',
      body: 'Deine Daten löschen, korrigieren oder Auskunft darüber anfragen kannst Du {link}.',
      linkLabel: 'hier',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Diese Liste ist für die Datenschutzrolle',
      description: 'Betroffenenanfragen bearbeitet der Workspace-Owner oder wer die Rolle „Datenschutz“ innehat.',
    },
    intro: {
      title: 'Betroffenenanfragen',
      body: 'Anfragen von Personen zu den Daten, die dieser Workspace über sie speichert. Jede muss innerhalb eines Monats nach Eingang beantwortet werden (Art. 12 Abs. 3 DSGVO). Bei komplexen Anfragen lässt sich die Frist zweimal um einen Monat verlängern – mit einer Begründung, die der Person mitzuteilen ist.',
    },
    filters: {
      label: 'Anfragen anzeigen',
      open: 'Offen',
      overdue: 'Überfällig',
      dueSoon: 'In 7 Tagen fällig',
      closed: 'Kürzlich beantwortet',
    },
    empty: {
      title: 'Keine Betroffenenanfragen',
      description: 'Wenn jemand nach seinen Daten fragt – in lumi oder per E-Mail, Post oder Telefon –, erscheint die Anfrage hier mit ihrer Frist.',
    },
    emptyFilter: 'In dieser Ansicht gibt es keine Anfragen.',
    truncated: 'Nicht alle Anfragen passen auf diese Seite. Die frühesten Fristen stehen oben.',
    badges: {
      overdue: 'Überfällig',
      dueSoon: 'Bald fällig',
      legalHold: 'Legal Hold',
      reviewReady: 'Bereit zur Prüfung',
      reviewReleased: 'Freigegeben',
      reviewDelivered: 'Zugestellt',
    },
    row: {
      received: 'Eingegangen',
      due: 'Antwort fällig',
      closed: 'Abgeschlossen',
      subject: 'Betrifft',
      channel: 'Eingang über',
      outcome: 'Ergebnis',
      extensions: 'Frist {count} von 2 Mal verlängert',
      postponed: 'Erinnerungen pausiert bis {date}',
      vetoWindow: 'Die Löschung lässt sich noch bis {date} stoppen',
      reviewFlagged: 'Deine Entscheidung nötig bei {flagged} von {total} Einträgen',
      reviewNoneFlagged: 'Keine Einträge markiert',
      reviewEmpty: 'Die Kopie enthält keine Einträge',
      reviewOpen: 'Prüfen',
      reviewReleased: 'Freigegeben, wird zugestellt',
      reviewDelivered: 'Zugestellt, wird abgeschlossen',
    },
    legalHold: {
      tenant: 'Für den ganzen Workspace besteht ein Legal Hold ({reason}).',
      subject: 'Für diese Person besteht ein Legal Hold ({reason}).',
      consequence: 'Die Daten dürfen nicht gelöscht werden. Die rechtmäßige Antwort ist eine Ablehnung, die genau diese Grundlage benennt – der Hold setzt die Frist nicht aus.',
    },
    automated: {
      pending: 'lumi beantwortet diese Anfrage selbst: Sobald du die Identität der Person geprüft und die Anfrage auf „In Bearbeitung“ gesetzt hast, stellt lumi die Kopie ihrer Daten zusammen. Sie wartet dann auf deine Prüfung. Nach deiner Freigabe erfährt die Person, wo sie sie herunterladen kann, und die Anfrage schließt sich von selbst.',
      running: 'lumi stellt gerade die Kopie der Daten dieser Person zusammen. Sie wartet danach auf deine Prüfung – erst nach deiner Freigabe erfährt die Person, wo sie sie herunterladen kann.',
    },
    detail: {
      show: 'Anfragende Person anzeigen',
      hide: 'Details ausblenden',
      loading: 'Details werden geladen…',
      loadError: 'Die Details dieser Anfrage konnten nicht geladen werden.',
      subjectLabel: 'Angegebener Name',
      subjectEmail: 'E-Mail-Adresse',
      subjectPhone: 'Telefonnummer',
      requestDetail: 'Was gefragt wurde',
      onBehalfReason: 'Stellvertretend erfasst, weil',
      extensionReason: 'Grund der Verlängerung',
      outcomeBasis: 'Benannte Grundlage',
      nothingOnFile: 'Kontakt',
      nothingOnFileValue: 'Zu dieser Anfrage sind weder Name noch Adresse noch Nachricht hinterlegt.',
    },
    kinds: {
      access: 'Kopie der eigenen Daten',
      rectification: 'Berichtigung',
      erasure: 'Löschung',
      restriction: 'Einschränkung der Verarbeitung',
      portability: 'Datenübertragbarkeit',
      objection: 'Widerspruch gegen die Verarbeitung',
    },
    statuses: {
      received: 'Eingegangen',
      verifying: 'Identität wird geprüft',
      in_progress: 'In Bearbeitung',
      awaiting_subject: 'Warten auf die Person',
      completed: 'Erledigt',
      refused: 'Abgelehnt',
      withdrawn: 'Zurückgezogen',
    },
    outcomes: {
      erased: 'Daten gelöscht',
      suppressed: 'Daten gelöscht, Mindestvermerk behalten',
      refused: 'Abgelehnt',
      partial: 'Teilweise erledigt',
      answered: 'Vollständig beantwortet',
    },
    subjectTypes: {
      person: 'Ein Personaldatensatz',
      tenant_user: 'Ein Mitglied ohne Personaldatensatz',
      candidate: 'Eine Bewerberin oder ein Bewerber',
      unlinked: 'Keinem Datensatz zugeordnet',
    },
    channels: {
      'self-service': 'Von der Person in lumi gestellt',
      'candidate-portal': 'Bewerberportal',
      email: 'E-Mail',
      post: 'Briefpost',
      phone: 'Telefon',
      unknown: 'Nicht erfasst',
    },
    actions: {
      advance: {
        verifying: 'Identität prüfen',
        in_progress: 'Bearbeitung beginnen',
        awaiting_subject: 'Auf die Person warten',
      },
      extend: 'Frist verlängern',
      close: 'Anfrage abschließen',
      postpone: 'Erinnerungen pausieren',
      veto: 'Vetofrist öffnen',
      hold: 'Legal Hold für Person',
      restrict: 'Verarbeitung einschränken',
      record: 'Anfrage erfassen',
    },
    confirmAutomated: {
      title: 'Kopie der Daten erstellen?',
      body: 'Mit „In Bearbeitung“ beauftragst du lumi, alles zusammenzustellen, was dieser Workspace über die Person speichert. Die Kopie geht noch nicht an die Person: Sie wartet auf deine Prüfung, und erst nach deiner Freigabe erfährt die Person, wo sie sie herunterladen kann. Tu das erst, wenn ihre Identität feststeht.',
      confirm: 'Beginnen',
    },
    toast: {
      advanced: 'Anfrage auf „{status}“ gesetzt.',
      extended: 'Frist bis {date} verlängert.',
      closed: 'Anfrage abgeschlossen.',
      postponed: 'Erinnerungen pausiert bis {date}.',
      vetoOpened: 'Vetofrist geöffnet. Die Löschung wartet 72 Stunden.',
      holdPlaced: 'Legal Hold gesetzt.',
      holdReleased: 'Legal Hold aufgehoben.',
      holdAttested: 'Legal Hold für weitere sechs Monate bestätigt.',
      restrictionPlaced: 'Verarbeitung eingeschränkt.',
      restrictionNotified: 'Benachrichtigung erfasst.',
      restrictionLifted: 'Einschränkung aufgehoben.',
      recorded: 'Anfrage erfasst.',
    },
    extend: {
      title: 'Frist verlängern',
      body: 'Art. 12 Abs. 3 DSGVO erlaubt zwei Verlängerungen um je einen Monat, wenn eine Anfrage komplex ist oder viele vorliegen. Teile das der Person innerhalb des ersten Monats mit, samt Begründung.',
      remaining: 'Verbleibende Verlängerungen: {count}',
      reasonLabel: 'Grund der Verzögerung',
      reasonHint: 'Wird mit der Anfrage gespeichert. Nenne der Person denselben Grund.',
      submit: 'Um einen Monat verlängern',
      errorReason: 'Bitte gib den Grund der Verzögerung an.',
    },
    close: {
      title: 'Anfrage abschließen',
      body: 'Eine abgeschlossene Anfrage lässt sich nicht wieder öffnen: Sie ist der Nachweis, wie und wann der Workspace geantwortet hat.',
      statusLabel: 'Wie wurde sie abgeschlossen?',
      outcomeLabel: 'Was wurde getan',
      outcomePlaceholder: 'Auswählen…',
      basisLabel: 'Rechtsgrundlage',
      basisHint: 'Die rechtliche Grundlage für das, was behalten oder abgelehnt wurde, z. B. eine Aufbewahrungspflicht oder Art. 12 Abs. 5 DSGVO.',
      submit: 'Anfrage abschließen',
      errorOutcome: 'Bitte wähle aus, was getan wurde.',
      errorBasis: 'Eine Ablehnung oder teilweise Antwort muss ihre Rechtsgrundlage nennen.',
      conflict: 'Die Anfrage konnte so nicht abgeschlossen werden. Ein Legal Hold oder ein offenes Widerspruchsfenster kann das Löschen der Daten verhindern, oder die Anfrage hat sich inzwischen geändert – lade die Liste neu und prüfe sie.',
    },
    record: {
      title: 'Anfrage erfassen',
      body: 'Für eine Anfrage, die per E-Mail, Briefpost oder Telefon kam. Die Monatsfrist läuft ab dem Tag des Eingangs, nicht ab heute. Eine erfasste Anfrage beginnt als eingegangen.',
      choose: 'Auswählen…',
      kindLabel: 'Art der Anfrage',
      channelLabel: 'Eingang über',
      receivedLabel: 'Eingegangen am',
      receivedHint: 'Der Tag, an dem die Anfrage beim Workspace ankam – spätestens heute.',
      subjectLabel: 'Betroffene Person',
      modes: {
        person: 'Person in Personal',
        candidate: 'Bewerbung in Recruiting',
        unlinked: 'Ohne Datensatz',
      },
      personLabel: 'Person suchen',
      personHint: 'Suche nach Name oder E-Mail-Adresse.',
      candidateLabel: 'Bewerberin oder Bewerber',
      candidateHint: 'Suche nach Name oder E-Mail-Adresse. Gefunden wird, wen deine Rolle in Recruiting öffnen darf.',
      candidateRefused: 'Deine Rollen in Recruiting erlauben keine Suche nach Bewerbungen. Wähle „Ohne Datensatz“ und gib den Namen an, den die Person genannt hat.',
      searchPlaceholder: 'Name oder E-Mail-Adresse',
      picker: {
        searching: 'Suche läuft…',
        typeMore: 'Mindestens {count} Zeichen',
        noMatch: 'Niemand gefunden. Ist die Person nirgends erfasst, wähle „Ohne Datensatz“.',
        error: 'Die Suche ist fehlgeschlagen. Ist die Person nirgends erfasst, wähle „Ohne Datensatz“.',
        refused: 'Deine Rollen erlauben keine Suche nach Bewerbungen.',
        rateLimited: 'Zu viele Suchen – gleich geht es weiter',
        resultsAnnouncement: 'Ein Treffer | {count} Treffer',
        clear: 'Auswahl entfernen',
      },
      nameLabel: 'Angegebener Name',
      nameHint: 'So, wie die Person unterschrieben oder sich vorgestellt hat.',
      emailLabel: 'E-Mail-Adresse (optional)',
      detailLabel: 'Was wird verlangt?',
      detailHint: 'Optional. Möglichst in den Worten der Person.',
      reasonLabel: 'Warum erfasst du das stellvertretend?',
      reasonHint: 'Zum Beispiel: Brief an die Personalabteilung vom 3. Mai oder Anruf am Empfang. Wird mit deinem Namen gespeichert.',
      submit: 'Anfrage erfassen',
      errorKind: 'Bitte wähle die Art der Anfrage.',
      errorChannel: 'Bitte wähle, wie die Anfrage eingegangen ist.',
      errorReceived: 'Bitte wähle den Tag, an dem die Anfrage eingegangen ist.',
      errorFuture: 'Eine Anfrage kann nicht in der Zukunft eingehen. Wähle heute oder einen früheren Tag.',
      errorPerson: 'Bitte wähle die Person aus der Suche oder „Ohne Datensatz“.',
      errorCandidate: 'Bitte wähle die Bewerbung aus der Suche oder „Ohne Datensatz“.',
      errorName: 'Bitte gib den Namen an, den die Person genannt hat.',
      errorEmail: 'Bitte gib eine gültige E-Mail-Adresse ein oder lass das Feld leer.',
      errorReason: 'Bitte gib an, warum du die Anfrage stellvertretend erfasst.',
    },
    errors: {
      conflict: 'Dieser Schritt ist nicht mehr möglich – die Anfrage hat sich inzwischen geändert. Lade die Liste neu.',
      notLinked: 'Diese Anfrage ist keinem Datensatz zugeordnet – es gibt niemanden, der gesperrt oder eingeschränkt werden kann.',
    },
    progress: {
      title: 'Löschung nach Modul',
      show: 'Löschstand anzeigen',
      hide: 'Löschstand ausblenden',
      loading: 'Löschnachweis wird geladen…',
      loadError: 'Der Löschnachweis konnte nicht geladen werden.',
      unlinked: 'Diese Anfrage ist keinem Datensatz zugeordnet, daher hat kein Modul dafür etwas gelöscht.',
      lastExecuted: 'erfasst am {date}',
      states: {
        done: 'Gelöscht',
        heldNothing: 'Nichts gespeichert',
        pending: 'Noch nicht erfasst',
        deferred: 'Aufgeschoben – Modul deaktiviert',
      },
      modules: {
        people: 'Personal',
        ats: 'Bewerbungen',
        time: 'Zeit',
        apprentice: 'Ausbildung',
        payroll: 'Lohnabrechnung',
        privacy: 'Datenschutz-Nachweis',
      },
    },
    postpone: {
      title: 'Erinnerungen pausieren',
      body: 'Stoppt die Erinnerungsmails bis zum gewählten Tag. Die Frist selbst verschiebt sich nicht – dafür die Anfrage verlängern.',
      untilLabel: 'Pausieren bis',
      untilHint: 'Spätestens bis zur Antwortfrist, {date}.',
      reasonLabel: 'Grund',
      reasonHint: 'Wird bei der Anfrage gespeichert, damit sich die Pause später begründen lässt.',
      submit: 'Erinnerungen pausieren',
      errorUntil: 'Bitte wähle den Tag, an dem die Erinnerungen wieder starten.',
      errorRange: 'Wähle einen Tag zwischen morgen und der Antwortfrist.',
      errorReason: 'Bitte gib den Grund für die Pause an.',
    },
    veto: {
      title: 'Vetofrist öffnen?',
      body: 'In den nächsten 72 Stunden wird die Löschung zurückgehalten: Die Anfrage kann nicht als gelöscht abgeschlossen werden. Nutze die Zeit, um zu prüfen, ob ein Legal Hold oder eine Ablehnung nötig ist. Die Frist lässt sich nicht vorzeitig schließen.',
      confirm: 'Vetofrist öffnen',
    },
    holds: {
      title: 'Legal Holds',
      intro: 'Ein Legal Hold (Löschsperre) verhindert, dass Daten gelöscht werden – durch eine Anfrage, die Aufbewahrungsregeln oder die Löschung des Workspace –, bis er aufgehoben wird. Jeder Hold muss alle sechs Monate neu bestätigt werden.',
      placeTenant: 'Legal Hold für den ganzen Workspace',
      empty: 'Kein Legal Hold aktiv.',
      lapsedNotice: 'Holds mit überschrittenem Bestätigungsdatum: {count}. Sie verhindern weiter jede Löschung – bestätige oder hebe sie auf.',
      scopeTenant: 'Ganzer Workspace',
      scopeSubject: 'Eine Person',
      lapsed: 'Bestätigung überfällig',
      placedAt: 'Gesetzt am',
      attestationDue: 'Bestätigen bis',
      basis: 'Rechtsgrundlage',
      attest: 'Weiter nötig',
      attestConfirm: {
        title: 'Hold beibehalten?',
        body: 'Du bestätigst, dass der Grund für den Hold weiter besteht. Er bleibt weitere sechs Monate bestehen.',
        confirm: 'Hold beibehalten',
      },
      release: {
        open: 'Aufheben',
        title: 'Legal Hold aufheben',
        warning: 'Ab jetzt dürfen die Daten, die dieser Hold geschützt hat, gelöscht werden – durch offene Anfragen, die Aufbewahrungsregeln oder die Löschung des Workspace. Das lässt sich nicht rückgängig machen.',
        reasonLabel: 'Warum wird der Hold nicht mehr gebraucht?',
        reasonHint: 'Wird mit deinem Namen gespeichert.',
        submit: 'Hold aufheben',
        errorReason: 'Bitte gib den Grund für die Aufhebung an.',
      },
      place: {
        titleTenant: 'Legal Hold für den ganzen Workspace',
        titleSubject: 'Legal Hold für diese Person',
        bodyTenant: 'Solange der Hold besteht, dürfen keine Daten dieses Workspace gelöscht werden – weder durch Anfragen noch durch die Aufbewahrungsregeln oder die Löschung des Workspace.',
        bodySubject: 'Solange der Hold besteht, dürfen keine Daten der Person gelöscht werden, die diese Anfrage nennt. Die Anfrage selbst muss trotzdem fristgerecht beantwortet werden.',
        reasonLabel: 'Grund',
        reasonHint: 'Zum Beispiel das Gerichtsverfahren oder die Behördenanfrage, die das Aufbewahren verlangt.',
        basisLabel: 'Rechtsgrundlage (optional)',
        basisHint: 'Ein kurzer Verweis, zum Beispiel die Vorschrift oder das Aktenzeichen.',
        submit: 'Hold setzen',
        errorReason: 'Bitte gib den Grund für den Hold an.',
      },
      errors: {
        notActive: 'Dieser Hold ist nicht mehr aktiv – er wurde inzwischen geändert. Die Liste wurde neu geladen.',
      },
    },
    restrictions: {
      title: 'Einschränkungen der Verarbeitung',
      intro: 'Ein eingeschränkter Datensatz darf aufbewahrt, aber nicht genutzt werden (Art. 18 DSGVO). Bevor eine Einschränkung aufgehoben wird, muss die Person informiert werden.',
      empty: 'Keine Verarbeitung ist eingeschränkt.',
      originSystem: 'Nach einer Löschung gesetzt',
      originRequest: 'Aus einer Anfrage',
      notified: 'Person informiert am {date}',
      notNotified: 'Person noch nicht informiert',
      placedAt: 'Eingeschränkt seit {date}',
      notifyOpen: 'Person informieren',
      notifyAgain: 'Neue Benachrichtigung erfassen',
      lift: 'Einschränkung aufheben',
      liftConfirm: {
        title: 'Einschränkung aufheben?',
        body: 'Der Datensatz kann wieder wie zuvor genutzt werden. Die Person wurde informiert.',
        bodySystem: 'Diese Einschränkung wurde automatisch über das gesetzt, was nach der Löschung der Daten der Person aufbewahrt wurde. Wird sie aufgehoben, lassen sich diese Datensätze wieder bearbeiten und nutzen. Hebe sie nur auf, wenn die Einschränkung nicht mehr nötig ist.',
        confirm: 'Einschränkung aufheben',
      },
      errors: {
        notActive: 'Diese Einschränkung ist nicht mehr aktiv, oder die Person wurde noch nicht informiert. Die Liste wurde neu geladen.',
      },
      place: {
        title: 'Verarbeitung einschränken',
        body: 'Der Datensatz der Person, die diese Anfrage nennt, bleibt erhalten, darf aber nicht mehr genutzt werden, bis die Einschränkung aufgehoben wird. Die Einschränkung wird mit dieser Anfrage verknüpft.',
        reasonLabel: 'Grund',
        reasonHint: 'Zum Beispiel: Die Person bestreitet die Richtigkeit der Daten.',
        submit: 'Einschränken',
        errorReason: 'Bitte gib den Grund für die Einschränkung an.',
      },
      notify: {
        title: 'Person informieren',
        body: 'Die Person muss informiert werden, bevor die Einschränkung aufgehoben wird (Art. 18 Abs. 3 DSGVO).',
        modeLabel: 'Wie wird die Person informiert?',
        modeSend: 'lumi sendet eine E-Mail',
        modeManual: 'Bereits anders informiert',
        manualOnly: 'Diese Einschränkung ist mit keiner Anfrage verknüpft, daher kennt lumi keine Adresse. Informiere die Person selbst und erfasse es hier.',
        employerLabel: 'In der E-Mail genannter Arbeitgeber',
        employerHint: 'Die Person muss erkennen können, wer ihre Daten eingeschränkt hat.',
        refLabel: 'Nachweis',
        refHint: 'Wie du sie informiert hast, zum Beispiel „Brief vom 3. Mai“ oder ein Aktenzeichen.',
        dateLabel: 'Informiert am',
        dateHint: 'Leer lassen für heute.',
        submitSend: 'E-Mail senden',
        submitManual: 'Benachrichtigung erfassen',
        sendRefused: 'Die E-Mail konnte nicht gesendet werden: Die Anfrage enthält keine E-Mail-Adresse. Informiere die Person auf anderem Weg und erfasse es.',
        errorEmployer: 'Bitte nenne den Arbeitgeber.',
        errorRef: 'Bitte gib einen Nachweis für die Benachrichtigung an.',
      },
    },
    review: {
      title: 'Kopie prüfen',
      intro: 'So liest die Person ihre Kopie. Markierte Einträge entscheidest du einzeln: freigeben oder zurückhalten (Art. 15 Abs. 4 DSGVO). Alles andere ist nur zum Lesen.',
      back: 'Zurück zu den Anfragen',
      counter: {
        undecided: '{undecided} von {flagged} Einträgen noch zu entscheiden',
        allDecided: 'Alle {flagged} markierten Einträge sind entschieden',
        noneFlagged: 'Kein Eintrag ist markiert – du kannst die Kopie direkt freigeben',
      },
      modules: {
        people: 'Personal',
        ats: 'Bewerbungen',
        time: 'Zeit',
        apprentice: 'Ausbildung',
      },
      moduleState: {
        notInstalled: 'Dieses Modul gehört nicht zu diesem Workspace, dort ist nichts gespeichert.',
        removed: 'Dieses Modul wurde aus dem Workspace entfernt, es ist nichts über die Person darin übrig.',
        unavailable: 'Dieses Modul war beim Zusammenstellen der Kopie nicht erreichbar – dieser Bereich fehlt in der Kopie. Setze die Anfrage auf „Auf die Person warten“ und danach mit „Bearbeitung beginnen“ wieder in Bearbeitung, dann stellt lumi die Kopie neu zusammen – oder gib sie bewusst ohne diesen Bereich frei.',
      },
      moduleEmpty: 'Hier ist nichts über die Person gespeichert.',
      delivered: 'Zugestellt – lumi schließt die Anfrage gleich ab',
      self: {
        title: 'Diese Anfrage betrifft dich selbst',
        description: 'Eine andere Datenschutz-Verantwortliche muss die Kopie prüfen. Du kannst die Anfrage stattdessen von Hand beantworten.',
      },
      unverified: 'lumi konnte gerade nicht prüfen, ob diese Anfrage dich selbst betrifft. Versuch es gleich noch einmal.',
      sectionMeta: 'Verarbeitung: {activity}',
      flagged: 'Markiert',
      flagReason: {
        written: 'Von jemand anderem über die Person geschrieben oder nennt andere Personen. Wäge ab, ob die Person diesen Eintrag lesen darf.',
        generic: 'Enthält möglicherweise Angaben über andere Personen oder stammt von anderen. Wäge nach Art. 15 Abs. 4 DSGVO ab.',
      },
      state: {
        undecided: 'Noch nicht entschieden',
        release: 'Wird freigegeben',
        withhold: 'Wird zurückgehalten',
      },
      decision: {
        group: 'Entscheidung zu einem Eintrag in „{section}“',
        release: 'Freigeben',
        withhold: 'Zurückhalten',
        changeReason: 'Grund ändern',
        reasonLabel: 'Grund für die Person',
        reasonHint: 'Die Person liest diesen Grund in ihrer Kopie. Schreib ihn für sie und gib den Inhalt des Eintrags nicht wieder.',
        reasonSave: 'Zurückhalten speichern',
        reasonRequired: 'Bitte nenne einen Grund.',
        saveError: 'Die Entscheidung konnte nicht gespeichert werden. Der Eintrag behält seinen bisherigen Stand.',
      },
      release: {
        action: 'Kopie freigeben',
        blocked: 'Entscheide zuerst die {undecided} offenen markierten Einträge, dann kannst du die Kopie freigeben.',
        confirmTitle: 'Kopie freigeben?',
        confirmBody: 'lumi erstellt jetzt die Kopie ohne die zurückgehaltenen Einträge ({withheld}), benachrichtigt die Person und schließt die Anfrage.',
        confirmBodyNone: 'lumi erstellt jetzt die Kopie, benachrichtigt die Person und schließt die Anfrage.',
        confirmLabel: 'Freigeben',
        done: 'Freigegeben – lumi stellt die Kopie zu',
      },
      errors: {
        undecided: 'Es sind noch markierte Einträge offen. Die Seite wurde neu geladen.',
        expired: 'Die Kopie ist abgelaufen – lumi erstellt eine neue, du siehst sie bald wieder hier',
        closed: 'Die Anfrage ist nicht mehr offen. Die Kopie lässt sich nicht mehr freigeben.',
      },
      notFound: {
        title: 'Hier wartet keine Kopie',
        description: 'Die Kopie ist abgelaufen oder wurde schon zugestellt. Läuft die Anfrage noch, erstellt lumi eine neue und du siehst sie bald wieder in der Liste.',
      },
    },
  },
  legalNotices: {
    title: 'Datenschutz- und KI-Hinweis für Mitarbeitende',
    intro: 'Was dieser Workspace seinen eigenen Mitarbeitenden zu Datenschutz und KI-Einsatz am Arbeitsplatz mitteilt.',
    titleLabel: 'Titel',
    contentLabel: 'Hinweistext',
    editMode: 'Bearbeiten',
    previewMode: 'Vorschau',
    followingVersion: 'Folgt lumi-Version {version}',
    branchedFromVersion: 'Eigener Text (abgezweigt von Version {version} am {date})',
    updateAvailable: 'Eine neuere lumi-Version ({version}) ist verfügbar.',
    compareVersions: 'Vergleichen',
    hideComparison: 'Vergleich ausblenden',
    yourText: 'Dein Text',
    lumiVersionHeading: 'lumi-Version {version}',
    adoptVersion: 'Version {version} übernehmen',
    adoptConfirm: 'Deinen Text in beiden Sprachen durch lumis Version {version} ersetzen?',
    adopted: 'lumis Version übernommen.',
    saved: 'Gespeichert.',
    noticeRequired: 'Der Hinweis kann nicht leer gespeichert werden.',
    lumiVersionUnavailable: 'lumis aktuelle Version konnte gerade nicht erreicht werden — versuche es gleich noch einmal.',
    forbidden: 'Du hast keinen Zugriff auf diesen Hinweis.',
    supportRefused: 'Ein Support-Zugriff reicht für diesen Hinweis nicht aus.',
    membershipUnavailable: 'Deine Berechtigung konnte gerade nicht geprüft werden — versuche es gleich noch einmal.',
    loadFailed: 'Der Hinweis konnte nicht geladen werden.',
    compareUnavailable: 'lumi war nicht erreichbar, daher sind Vergleich und Übernehmen gerade nicht verfügbar.',
    blanksOpenRefusal: 'Der Text enthält noch offene Lücken: {list}. Fülle sie oben aus oder ersetze sie durch eigene Worte, bevor du speicherst.',
    unsavedWarning: 'Deine Änderungen an {name} sind noch nicht gespeichert.',
    demoDisclaimer: 'DIES IST DIE DEMOVERSION FÜR EIN FIKTIVES DEMO-UNTERNEHMEN. KEIN RECHTSVERBINDLICHES DOKUMENT.',
    blanks: {
      lead: 'lumis Vorlagen brauchen diese Angaben von dir. Du trägst jede nur einmal ein – sie wird in alle Texte unten eingesetzt, in beiden Sprachen.',
      saved: 'Gespeichert.',
      complete: 'Alle erforderlichen Angaben liegen vor.',
      suggested: 'Aus deinem Firmenprofil übernommen – bitte prüfen, dann speichern.',
      keys: {
        company_name: { label: 'Firmenname', hint: 'Der rechtliche Name dieses Workspace, wie er im Hinweis erscheinen soll.' },
        company_address: { label: 'Firmenanschrift', hint: 'Die Postanschrift, unter der Mitarbeitende und Bewerbende dich erreichen können.' },
        privacy_contact: { label: 'Datenschutz-Kontakt', hint: 'Wen man zum Datenschutz fragen kann — ein Name, eine Rolle oder eine E-Mail-Adresse.' },
        applicant_retention: { label: 'Aufbewahrungsdauer für Bewerbungsdaten', hint: 'Wie lange erfolglose Bewerbungen vor der Löschung aufbewahrt werden.' },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Damit deine Rechtstexte vollständig sind',
      progress: '{done} von {total} erledigt',
      facts: { title: 'Angaben für alle Texte', hint: 'Firmenname, Anschrift, Datenschutz-Kontakt und mehr – in jeden Text unten eingesetzt.' },
      imprintAction: 'Impressum eintragen',
    },
    candidate: {
      heading: 'Hinweise für Bewerbende',
      intro: 'Die rechtlichen Hinweise, die dieser Workspace Bewerbenden im Karriereportal zeigt.',
      unavailable: 'Die Hinweise für Bewerbende sind gerade nicht verfügbar.',
      noticeRequired: 'Dieser Hinweis wird Bewerbenden angezeigt und darf nicht leer sein. Ersetze den Text oder übernimm lumis Fassung.',
      imprintRequired: 'Das Impressum kann nicht geleert werden, solange das Portal online ist. Ersetze den Text, statt ihn zu entfernen.',
      privacy: {
        title: 'Datenschutzhinweise für Bewerbende',
        subtitle: 'Diese Version wird Bewerbenden im Karriereportal angezeigt. Ohne sie bleibt das Karriereportal offline.',
      },
      aiUsage: {
        title: 'Hinweis zum KI-Einsatz für Bewerbende',
        subtitle: 'Dieser Text wird Bewerbenden auf dem Karriereportal angezeigt.',
      },
      imprint: {
        title: 'Impressum des Karriereportals',
        subtitle: 'Dieser Text wird von jeder Seite des Portals verlinkt.',
        hint: 'Das Impressum ist gesetzlich vorgeschrieben (§ 5 DDG). Dein Karriereportal bleibt offline, solange es in keiner Sprache gespeichert ist.',
        fallsBack: 'Dein Impressum ist gespeichert. Sprachen ohne eigenes Impressum zeigen im Portal die {language}-Fassung.',
      },
      history: {
        title: 'Was haben wir wann angezeigt?',
        hint: 'Den genauen Text nachschlagen, der zu einem Zeitpunkt in der Vergangenheit auf dieser Seite stand – für die Frage einer bewerbenden Person oder einer Aufsichtsbehörde.',
        open: 'Nachschlagen',
        hide: 'Schließen',
        dateLabel: 'Datum und Uhrzeit',
        localeLabel: 'Sprache',
        lookUp: 'Text anzeigen',
        periodClosed: 'Live von {from} bis {until}.',
        periodOpen: 'Live seit {from} – weiterhin der aktuelle Text.',
        sourceLumi: 'lumis veröffentlichte Version {version}, Wort für Wort.',
        sourceLumiUnversioned: 'lumis veröffentlichter Text.',
        sourceTenant: 'Der eigene Text dieses Workspace, abgezweigt von lumi-Version {version}.',
        sourceTenantOwn: 'Der eigene Text dieses Workspace.',
        none: 'So weit reicht die Aufzeichnung nicht zurück.',
        provenanceFollowing: 'Bekannt ist: Diese Seite ist eine Kopie von lumi-Version {version} und wurde hier nie überschrieben.',
        provenanceBranched: 'Bekannt ist: Diese Seite stammt aus lumi-Version {version} und wurde am {date} überschrieben.',
        provenanceUnknown: 'Zu dieser Seite ist für die Zeit davor nichts weiter aufgezeichnet.',
        futureRefused: 'Diese Aufzeichnung sagt, was eine Seite angezeigt hat – nicht, was sie anzeigen wird. Wähle einen Zeitpunkt in der Vergangenheit.',
        invalidRefused: 'Wähle ein Datum und eine Sprache für die Abfrage.',
        failed: 'Die Aufzeichnung konnte gerade nicht gelesen werden. Bitte versuche es erneut.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Dieser Hinweis ist derzeit nicht verfügbar.',
  },
  dataImportHub: {
    nav: 'Daten-Import',
    title: 'Daten-Import & -Export',
    intro: 'Bestandsdaten zentral in die Module importieren und exportieren. Jede Aktion läuft im Ziel-Modul unter deiner dortigen Berechtigung.',
    locked: 'Keine Berechtigung in diesem Modul',
    lockedDetail: 'Für {module} fehlt dir die Import-Berechtigung (data_import.manage). Bitte eine:n Modul-Admin darum oder lass dir die Rolle geben.',
    plan: {
      title: 'Import-Plan',
      run: 'Fehlende Werte jetzt anlegen',
      summary: '{count} Werte fehlen im Modul {module} und können dort als Import angelegt werden.',
      truncated: 'Liste gekürzt — es werden bis zu 200 fehlende Werte je Feld erkannt.',
      forbidden: 'Dafür fehlt dir die Berechtigung im Modul {module}.',
      running: 'Companion-Import läuft…',
      waiting: 'Warte, bis die neuen Werte ins Ziel-Modul übernommen sind…',
      rerunning: 'Probelauf im Ziel-Modul wird neu gestartet…',
      done: 'Erledigt — der Probelauf läuft mit den neuen Werten.',
      failed: 'Der Companion-Import ist fehlgeschlagen.',
      confirmTitle: 'Fehlende Werte anlegen?',
      confirmBody: '{count} Werte fehlen im Modul {module}. Sollen sie dort jetzt per Import angelegt werden? Danach startet der Probelauf automatisch neu.',
      companionErrors: 'Der Companion-Probelauf meldet Fehler — bitte im Modul prüfen.',
      projectionTimeout: 'Die Übernahme ins Ziel-Modul dauert länger als erwartet — bitte später erneut den Probelauf starten.',
    },
    createField: {
      title: 'Neues eigenes Feld anlegen',
      intro: 'Lege ein eigenes Feld für die Spalte „{column}“ an. Es steht danach überall im ATS zur Verfügung.',
      typeHint: 'Auswahlfelder (Select/Mehrfachauswahl) legst du in der Feld-Verwaltung an.',
      sensitiveNotImportable: 'Felder besonderer Kategorien (Art. 9) werden angelegt, sind aber bewusst kein Import-Ziel.',
      submit: 'Feld anlegen',
      label: 'Label',
      keyLabel: 'Feld-Schlüssel (Key)',
      keyHint: 'Nur Kleinbuchstaben, Zahlen und Unterstriche',
      typeLabel: 'Typ',
      types: {
        text: 'Text',
        textarea: 'Textarea',
        number: 'Zahl',
        date: 'Datum',
        checkbox: 'Checkbox',
      },
      sensitivityLabel: 'Welche Art von Daten enthält dieses Feld?',
      sensitivityUnanswered: 'Bitte wählen',
      sensitivityNone: 'Keine besondere Kategorie',
      sensitivityHint: 'Daten besonderer Kategorien (Art. 9 DSGVO) dürfen keine automatisierten Entscheidungen über eine Bewerbung auslösen.',
      sensitivityCategories: {
        racialEthnic: 'Rassische oder ethnische Herkunft',
        politicalOpinion: 'Politische Meinungen',
        religiousPhilosophical: 'Religiöse oder weltanschauliche Überzeugungen',
        tradeUnion: 'Gewerkschaftszugehörigkeit',
        genetic: 'Genetische Daten',
        biometricId: 'Biometrische Identifizierung',
        health: 'Gesundheitsdaten',
        sexLifeOrientation: 'Sexualleben oder sexuelle Orientierung',
      },
      sensitivityRequired: 'Bitte gib an, welche Art von Daten dieses Feld enthält.',
    },
    entities: {
      person: 'Mitarbeitende',
      orgUnit: 'Org-Einheiten',
      employmentContract: 'Verträge',
      job: 'Stellen',
      candidate: 'Kandidat:innen',
      application: 'Bewerbungen',
      client: 'Kunden',
      project: 'Projekte',
      timeEntry: 'Zeiteinträge',
      leaveRequest: 'Abwesenheiten',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      contractType: {
        permanent: 'unbefristet',
        fixed_term: 'befristet',
        mini_job: 'Minijob',
        midi_job: 'Midijob (Übergangsbereich)',
        working_student: 'Werkstudent',
        apprenticeship: 'Ausbildung',
        internship: 'Praktikum',
        freelance: 'Freie Mitarbeit / Honorar',
        managing_director: 'Geschäftsführer / Vorstand',
        other: 'Sonstige',
      },
      workTimeArrangement: {
        full_time: 'Vollzeit',
        part_time: 'Teilzeit',
        marginal: 'geringfügig (Minijob)',
        variable: 'variabel / flexibel',
      },
      status: {
        draft: 'Entwurf',
        active: 'Aktiv',
        on_hold: 'Pausiert',
        terminated: 'Beendet',
        inactive: 'Inaktiv',
      },
      type: {
        department: 'Abteilung',
        location: 'Standort',
        team: 'Team',
        cost_center: 'Kostenstelle',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'Externe ID',
        type: 'Typ',
        name: 'Name',
        code: 'Schlüssel',
        description: 'Beschreibung',
        parentExternalId: 'Übergeordnete Einheit',
        parentCode: 'Übergeordnete Einheit (Schlüssel)',
        addressLine1: 'Adresse',
        postalCode: 'PLZ',
        city: 'Stadt',
        country: 'Land',
        active: 'Aktiv',
      },
      person: {
        externalId: 'Externe ID',
        employeeNumber: 'Personalnummer',
        firstName: 'Vorname',
        lastName: 'Nachname',
        salutation: 'Anrede',
        gender: 'Geschlecht',
        email: 'E-Mail',
        phone: 'Telefon',
        birthDate: 'Geburtsdatum',
        nationality: 'Staatsangehörigkeit',
        maritalStatus: 'Familienstand',
        addressLine1: 'Adresse',
        addressLine2: 'Adresszusatz',
        postalCode: 'PLZ',
        city: 'Stadt',
        country: 'Land',
        workCountry: 'Arbeitsort (Land)',
        primaryLocale: 'Sprache',
        status: 'Status',
        primaryOrgUnitExternalId: 'Abteilung / Einheit',
        primaryOrgUnitCode: 'Abteilung / Einheit (Schlüssel)',
        supervisorExternalId: 'Fachliche Führung',
      },
      employmentContract: {
        externalId: 'Externe ID',
        personExternalId: 'Person',
        contractReference: 'Vertragsnummer',
        status: 'Vertragsstatus',
        startDate: 'Eintrittsdatum',
        endDate: 'Austrittsdatum',
        probationEndDate: 'Probezeitende',
        contractType: 'Vertragsart',
        position: 'Position / Tätigkeit',
        primaryOrgUnitExternalId: 'Abteilung / Einheit',
        supervisorExternalId: 'Führungskraft',
        workTimeArrangement: 'Beschäftigungsumfang',
        weeklyHours: 'Wochenstunden',
        vacationDaysPerYear: 'Urlaubsanspruch (Tage/Jahr)',
        collectiveAgreementCode: 'Tarifbindung',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit-Log', subtitle: 'Wer hat was in deinem Workspace getan.',
    noAccess: 'Kein Zugriff', noAccessHint: 'Für diese Seite brauchst du die Audit-Log-Berechtigung.',
    empty: 'Noch keine Audit-Ereignisse', emptyHint: 'Aktionen in deinem Workspace erscheinen hier.',
    loading: 'Wird geladen…', loadMore: 'Mehr laden',
    filters: { from: 'Von', to: 'Bis', action: 'Aktion', category: 'Kategorie', actor: 'Akteur', outcome: 'Ergebnis', search: 'Suche', searchHint: 'Objekt oder Akteur…', apply: 'Anwenden', reset: 'Zurücksetzen', all: 'Alle', actorType: 'Akteurstyp' },
    columns: { time: 'Zeit', actor: 'Akteur', action: 'Aktion', subject: 'Objekt', outcome: 'Ergebnis' },
    outcome: { success: 'Erfolg', denied: 'Verweigert', failure: 'Fehler' },
    actorType: { user: 'Benutzer', system_admin: 'System-Admin', support: 'Support', service: 'Dienst', system: 'System' },
    categories: { auth: 'Authentifizierung', access: 'Zugriff', data: 'Daten', admin: 'Verwaltung', lifecycle: 'Lebenszyklus', export: 'Export', security: 'Sicherheit' },
    export: { csv: 'CSV exportieren', ndjson: 'NDJSON exportieren' },
    detail: { roles: 'Rollen', action: 'Aktion', actorId: 'Akteur-ID', onBehalfOf: 'Im Auftrag von', ip: 'IP-Adresse', source: 'Quelle', correlationId: 'Korrelations-ID', changes: 'Änderungen', before: 'Vorher', after: 'Nachher', details: 'Details' },
    actions: { login: { succeeded: 'Anmeldung erfolgreich', failed: 'Anmeldung fehlgeschlagen', attempts_flagged: 'Wiederholte fehlgeschlagene Anmeldeversuche', locked: 'Konto gesperrt' }, sso: { login_succeeded: 'SSO-Anmeldung erfolgreich', connection_changed: 'SSO-Verbindung geändert' }, password: { reset_requested: 'Passwort-Zurücksetzung angefordert', reset_completed: 'Passwort zurückgesetzt' }, refresh_token: { revoked: 'Sitzung widerrufen' }, user: { signed_up: 'Benutzer registriert', unlocked: 'Konto entsperrt', disabled: 'Konto deaktiviert', enabled: 'Konto aktiviert', closed: 'Konto geschlossen' }, passkey: { revoked: 'Passkeys durch Admin entfernt' }, role: { changed: 'Rolle geändert' }, module_access: { changed: 'Modulzugriff geändert' }, access: { ownership_transferred: 'Eigentümerschaft übertragen', member_removed: 'Mitglied entfernt', suite_roles_changed: 'Suite-Rollen geändert' }, tenant: { created: 'Tenant angelegt', lifecycle: 'Tenant-Lebenszyklus geändert', exported: 'Tenant exportiert' }, module: { activated: 'Modul aktiviert', deactivated: 'Modul deaktiviert' }, plan: { changed: 'Plan geändert' }, tenant_ai_settings: { changed: 'KI-Einstellungen geändert' }, tenant_role_editing: { changed: 'Rollenbearbeitung geändert' }, settings: { changed: 'Einstellungen geändert' }, test_data: { seeded: 'Testdaten erstellt', reset: 'Testdaten zurückgesetzt' }, onboarding: { setup_chosen: 'Einrichtung gewählt', demo_started: 'Demomodus gestartet', demo_seeded: 'Demodaten erstellt', demo_seed_failed: 'Erstellen der Demodaten fehlgeschlagen', demo_wipe_started: 'Löschen der Demodaten gestartet', demo_wiped: 'Demodaten gelöscht', demo_wipe_failed: 'Löschen der Demodaten fehlgeschlagen', setup_finished: 'Einrichtung abgeschlossen', demo_denied: 'Demomodus abgelehnt', module_topup: 'Demodaten für neues Modul ergänzt', demo_reset_started: 'Zurücksetzen der Demo gestartet', demo_tier_switch_started: 'Wechsel zur vollständigen Demo gestartet', demo_rebuilt: 'Demo neu aufgebaut' }, company_profile: { created: 'Firmenprofil erstellt', updated: 'Firmenprofil geändert' }, org_scenario: { activated: 'Organisationsszenario aktiviert' }, people_data: { wiped: 'Personaldaten gelöscht' }, ats_data: { wiped: 'Recruiting-Daten gelöscht' }, time_data: { wiped: 'Zeiterfassungsdaten gelöscht' }, apprentice_data: { wiped: 'Ausbildungsdaten gelöscht' }, audit_log: { exported: 'Audit-Log exportiert' }, billing_charge: { paid: 'Zahlung abgebucht', failed: 'Zahlung fehlgeschlagen', refunded: 'Zahlung erstattet', chargeback: 'Rückbuchung erhalten' }, invoice: { issued: 'Rechnung ausgestellt' }, mandate: { created: 'Karte hinterlegt', replaced: 'Karte ersetzt' }, promo_code: { redeemed: 'Aktionscode eingelöst' }, billing_account: { converted: 'Testphase in Abo umgewandelt', delinquent: 'Konto überfällig', purged: 'Zahlungsdaten gelöscht' }, dunning_case: { opened: 'Zahlungserinnerung gestartet' }, enforcement: { opened: 'Durchsetzung gestartet', advanced: 'Durchsetzung eskaliert', cleared: 'Durchsetzung aufgehoben' }, billing_exempt: { changed: 'Abrechnungsbefreiung geändert' }, billing_data: { wiped: 'Zahlungsdaten gelöscht', generated: 'Test-Zahlungsdaten erzeugt' }, checkout: { completed: 'Bestellung abgeschlossen', denied: 'Bestellung abgelehnt' }, job: { created: 'Stelle erstellt', updated: 'Stelle aktualisiert', submitted: 'Stelle eingereicht', archived: 'Stelle archiviert', deleted: 'Stelle gelöscht' }, application: { created: 'Bewerbung eingegangen', updated: 'Bewerbung aktualisiert', transitioned: 'Bewerbungsstatus geändert', withdrawn: 'Bewerbung zurückgezogen', transferred: 'Bewerbung auf andere Stelle übertragen', transfer_declined: 'Übertragung der Bewerbung abgelehnt', rejected: 'Bewerbung abgelehnt', deleted: 'Bewerbung gelöscht', emailed: 'E-Mail zur Bewerbung gesendet' }, interview: { proposed: 'Interview vorgeschlagen', confirmed: 'Interview bestätigt', cancelled: 'Interview abgesagt' }, candidate: { anonymized: 'Kandidat anonymisiert', emailed: 'E-Mail an Kandidat gesendet', identity_changed: 'Kandidatendaten geändert', identity_split: 'Kandidat auf eigenen Eintrag getrennt', identity_merged: 'Bewerbung zur Person mit dieser Adresse verschoben' }, candidate_dossier: { accessed: 'Kandidat hat eigene Daten abgerufen' }, workflow: { deleted: 'Workflow gelöscht', definition: { published: 'Workflow veröffentlicht' } }, task: { blocking_overridden: 'Blockierende Aufgabe übergangen', auto_cancelled: 'Aufgabe automatisch abgebrochen' }, support_access: { requested: 'Support-Zugriff angefragt', approved: 'Support-Zugriff freigegeben', denied: 'Support-Zugriff abgelehnt', revoked: 'Support-Zugriff beendet', expired: 'Support-Zugriff abgelaufen', request_expired: 'Support-Zugriffsanfrage abgelaufen' }, ai_action: { executed: 'KI-Aktion ausgeführt' }, assistant_run: { proposed: 'lumi hat eine Aktion vorgeschlagen', approved: 'lumi-Aktion freigegeben', refused: 'lumi-Aktion abgelehnt', failed: 'lumi-Aktion fehlgeschlagen' }, assistant_turn: { fanned_out: 'lumi-Anfrage an mehrere Module' }, payroll_export_run: { created: 'Lohnexport gestartet', completed: 'Lohnexport abgeschlossen', failed: 'Lohnexport fehlgeschlagen', downloaded: 'Lohnexport heruntergeladen' }, payroll_period: { closed: 'Abrechnungsmonat abgeschlossen', reopened: 'Abrechnungsmonat wieder geöffnet' }, payroll_connection: { updated: 'Lohnanbindung geändert' }, payroll_master_data: { exported: 'Lohnstammdaten exportiert' }, wage_type: { created: 'Lohnart angelegt', updated: 'Lohnart geändert', deleted: 'Lohnart gelöscht', starter_catalog_applied: 'Standard-Lohnarten hinzugefügt' }, wage_assignment: { created: 'Lohnbestandteil hinzugefügt', updated: 'Lohnbestandteil geändert', deleted: 'Lohnbestandteil entfernt' }, one_time_payment: { created: 'Einmalzahlung hinzugefügt', updated: 'Einmalzahlung geändert', deleted: 'Einmalzahlung entfernt' }, payslip: { filed: 'Lohnabrechnungen abgelegt' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Verbinde deinen Identity Provider (OIDC), damit sich dein Team darüber anmeldet.',
    issuerUrl: 'Issuer-URL (OIDC Discovery)',
    clientId: 'Client-ID',
    clientSecret: 'Client-Secret',
    clientSecretKeep: 'Leer lassen, um das gespeicherte Secret beizubehalten',
    label: 'Anzeigename',
    allowedDomains: 'Erlaubte E-Mail-Domains (kommagetrennt)',
    jitEnabled: 'Benutzer bei erster Anmeldung automatisch anlegen (JIT)',
    jitDefaults: 'Standard-Modulzugriffe für neue Benutzer',
    jitModulePlaceholder: 'Modul wählen',
    jitRoles: 'Rollen',
    jitCatalogUnreadable: 'Die Rollen dieses Moduls konnten nicht gelesen werden. Die gespeicherten Rollen bleiben unverändert.',
    jitUnknownRole: '{key} (unbekannt)',
    addJit: 'Modul hinzufügen',
    remove: 'Entfernen',
    redirectUri: 'Redirect-URI (im IdP hinterlegen)',
    copy: 'Kopieren',
    test: 'Verbindung testen',
    testOk: 'Discovery erfolgreich.',
    testFailed: 'Test fehlgeschlagen',
    save: 'Speichern',
    saved: 'Gespeichert.',
    delete: 'Verbindung entfernen',
    deleteConfirm: 'Diese SSO-Verbindung wirklich entfernen?',
    enforce: 'Anmeldung nur über SSO erzwingen',
    enforceHint: 'Passwort-Anmeldung wird für alle außer Systemadministratoren und dem Workspace-Eigentümer deaktiviert.',
    noConnection: 'Es ist noch keine SSO-Verbindung konfiguriert.',
    deleted: 'Verbindung entfernt.',
    enforceEnabled: 'Anmeldung ist jetzt nur noch über SSO möglich.',
    enforceDisabled: 'Anmeldung mit Passwort ist wieder möglich.',
    jitNeedsVerifiedDomain: 'Konten werden nur für Adressen auf einer bestätigten Domain automatisch angelegt.',
    domainsTitle: 'E-Mail-Domains',
    domainsIntro: 'Eine Domain zählt für die SSO-Anmeldung erst, wenn du nachgewiesen hast, dass sie euch gehört: Hinterlege diesen TXT-Eintrag im DNS der Domain und prüfe ihn dann. Bereits verknüpfte Konten melden sich währenddessen weiter an.',
    domainStatus: { pending: 'Nicht bestätigt', verified: 'Bestätigt', legacy: 'Bald bestätigen' },
    domainLegacyUntil: 'Bestätigen bis {date}',
    domainRecordName: 'Name des Eintrags (TXT)',
    domainRecordValue: 'Wert des Eintrags',
    domainVerify: 'Eintrag prüfen',
    domainVerified: '{domain} ist bestätigt.',
    domainError: { record_not_found: 'Unter diesem Namen gibt es noch keinen TXT-Eintrag. DNS-Änderungen können eine Weile brauchen.', value_mismatch: 'Es gibt einen TXT-Eintrag, aber sein Wert stimmt nicht. Kopiere den Wert genau.', dns_error: 'Die DNS-Abfrage ist fehlgeschlagen. Bitte versuche es in ein paar Minuten noch einmal.' },
  },
  users: {
    // What survives /admin/users (retired, ADR 0088 §8.2): the module and suite
    // role names other admin surfaces still render.
    suiteSuiteAdmin: 'Admin',
    suiteBillingManager: 'Billing Manager',
    suiteSupportAgent: 'Support Agent',
    suiteDataProtection: 'Datenschutzbeauftragte:r',
    moduleNames: {
      ats: 'Recruiting',
      time_tracking: 'Zeit',
      people: 'Personal',
      apprenticeship: 'Ausbildung',
    },
  },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'KI-Agent verbinden',
    heading: 'Ein KI-Agent möchte in deinem Namen handeln',
    intro: 'Ein KI-Client, der sich „{client}“ nennt, möchte im Workspace {workspace} als du in lumi arbeiten.',
    fields: {
      client: 'Nennt sich',
      redirectHost: 'Schickt dich zurück an',
      website: 'Angegebene Website',
      workspace: 'Im Workspace',
    },
    scopesHeading: 'Er möchte:',
    scope: {
      read: 'Lesen, was du in lumi sehen kannst',
      act: 'Aktionen in deinem Namen vorschlagen und ausführen — jede Aktion braucht deine Bestätigung',
      ask: 'lumi Fragen stellen',
    },
    meaning: {
      heading: 'Was „Zulassen“ bedeutet',
      asYou: 'Er handelt als du, mit genau deinen Berechtigungen in diesem Workspace — nie mit mehr.',
      egress: 'Was er in lumi liest, geht an den Anbieter hinter „{client}“ — außerhalb von lumi.',
      revocable: 'Du kannst die Verbindung jederzeit auf deiner Kontoseite beenden.',
    },
    standing: {
      label: 'Aktionen an meinen eigenen Datensätzen ausführen, ohne jedes Mal zu fragen',
      hint: 'Gilt nie für Datensätze anderer Personen oder für belastende Entscheidungen — dort wird immer gefragt. Du kannst das jederzeit auf deiner Kontoseite ändern.',
    },
    rolePins: {
      title: 'Rolle je Modul',
      hint: 'Wo du mehr als eine Rolle hast, wähle die, in der der Agent arbeitet. Er darf nie mehr, als diese Rolle erlaubt.',
      default: 'Standard des Moduls ({rule})',
      defaultRule: {
        first_assigned: 'deine zuerst zugewiesene Rolle',
        first_by_key: 'deine erste Rolle nach ihrem Schlüssel',
        all_roles: 'alle deine Rollen zusammen',
      },
      modules: {
        ats: 'Recruiting',
        time: 'Zeit',
        people: 'Personal',
      },
      notHeld: 'Die gewählte Rolle hast du in diesem Modul nicht mehr. Bitte wähle neu.',
    },
    disabled: {
      title: 'Externe KI-Agenten sind in diesem Workspace ausgeschaltet',
      body: 'Inhaber oder Admins können sie unter Administration → Externe KI-Agenten einschalten. Bis dahin kannst du diese Anfrage nur ablehnen.',
    },
    actions: {
      allow: 'Zulassen',
      deny: 'Ablehnen',
    },
    returning: 'Du wirst zu {client} zurückgeleitet …',
    invalid: {
      title: 'Diese Anmeldeanfrage ist nicht mehr gültig',
      hint: 'Starte die Verbindung in deinem KI-Client neu.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Externe KI-Agenten',
    cardTitle: 'Externe KI-Agenten',
    noAccess: 'Kein Zugriff',
    noAccessHint: 'Nur Workspace-Inhaber und Suite-Admins können diese Einstellung ändern.',
    intro: 'Ist das eingeschaltet, können Mitglieder ihren eigenen KI-Client verbinden — Claude Code, OpenClaw, … — und ihn in diesem Workspace in ihrem Namen handeln lassen.',
    points: {
      asMember: 'Ein Agent arbeitet mit genau den Berechtigungen des Mitglieds, das ihn verbunden hat — nie mit mehr.',
      confirmed: 'Jede Aktion, die er vorschlägt, bestätigt dieses Mitglied, bevor sie geschieht.',
      adverse: 'Belastende Entscheidungen über andere Personen brauchen immer das lumi-Panel; ein Agent kann sie nie bestätigen.',
    },
    egress: {
      title: 'Wohin die Daten der Mitglieder gehen',
      body: 'Was ein Agent liest, fließt an den KI-Client, den das Mitglied verbindet — einen Empfänger außerhalb der Auftragsverarbeitungskette von lumi, gewählt von deinem Workspace und dem Mitglied.',
      worksCouncil: 'Ob Mitglieder solche Clients nutzen dürfen, entscheidest du als Arbeitgeber — denk daran, deinen Betriebsrat einzubeziehen.',
    },
    switchLabel: 'Mitgliedern erlauben, externe KI-Agenten zu verbinden',
    saving: 'Wird gespeichert …',
    activeConnections: 'Keine Verbindung aktiv. | 1 Verbindung aktiv. | {n} Verbindungen aktiv.',
    offHint: 'Ausschalten beendet sofort jede Verbindung in diesem Workspace.',
    roleNote: 'Nur der Workspace-Inhaber oder ein Suite-Admin kann das ändern.',
    savedOn: 'Externe KI-Agenten sind eingeschaltet. Mitglieder können jetzt ihren KI-Client verbinden.',
    savedOff: 'Externe KI-Agenten sind ausgeschaltet. | Externe KI-Agenten sind ausgeschaltet. 1 Verbindung wurde beendet. | Externe KI-Agenten sind ausgeschaltet. {n} Verbindungen wurden beendet.',
    disableConfirm: {
      title: 'Externe KI-Agenten ausschalten?',
      body: 'Gerade ist keine Verbindung aktiv; Mitglieder können sich danach nicht mehr verbinden. | Das beendet sofort 1 Verbindung. | Das beendet sofort {n} Verbindungen.',
      confirm: 'Ausschalten',
    },
  },
  supportAccess: {
    revokeConfirm: 'Der Support-Zugriff wird sofort beendet. Das Support-Team verliert damit den Zugang zu diesem Workspace.',
    title: 'Support-Zugriff',
    subtitle: 'Befristeter, von dir freigegebener Zugriff unseres Supports auf deinen Workspace.',
    noAccess: 'Kein Zugriff',
    noAccessHint: 'Nur Workspace-Inhaber und Suite-Admins können Support-Zugriffsanfragen prüfen.',
    empty: 'Kein Support-Zugriff angefragt',
    emptyHint: 'Wenn unser Support für ein Ticket Zugriff auf deinen Workspace braucht, erscheint die Anfrage hier.',
    pendingTitle: 'Zugriffsanfrage offen',
    pendingIntro: '{supporter} bittet um {days} Tage Zugriff auf diesen Workspace.',
    activeTitle: 'Support-Zugriff ist aktiv',
    activeIntro: '{supporter} kann derzeit in diesem Workspace arbeiten.',
    historyTitle: 'Verlauf',
    revokeHint: 'Das Beenden wirkt innerhalb einer Minute.',
    expiringNow: 'Läuft gerade ab',
    remainingDays: 'noch {days} T {hours} Std',
    remainingHours: 'noch {hours} Std {minutes} Min',
    remainingMinutes: 'noch {minutes} Min',
    fields: {
      requestedAt: 'Angefragt',
      ticket: 'Support-Ticket',
      duration: 'Dauer',
      durationValue: '{days} Tage',
      reason: 'Begründung',
      approvedBy: 'Freigegeben von',
      expiresAt: 'Läuft ab',
      remaining: 'Restzeit',
      grantedModules: 'Erteilte Rollen',
    },
    consent: { allRoles: 'Die unterstützende Person kann in jede Rolle dieser Module wechseln — sie sieht, was deine Mitarbeitenden sehen, nicht nur die Admin-Ansicht.', modulesHeading: 'Diese Freigabe umfasst:', via: 'über {module}',
      heading: 'Das gibst du frei',
      data: 'Der Support kann auf die Daten dieses Workspace in allen aktiven Modulen zugreifen – einschließlich personenbezogener Daten von Mitarbeitenden und Bewerbenden.',
      audited: 'Jede Aktion wird in deinem Audit-Log protokolliert und als Support-Aktion gekennzeichnet.',
      duration: 'Der Zugriff endet automatisch nach {days} Tagen.',
      revocable: 'Du kannst ihn jederzeit beenden; das wirkt innerhalb einer Minute.',
    },
    actions: { approve: 'Zugriff freigeben', deny: 'Ablehnen', revoke: 'Zugriff jetzt beenden' },
    status: {
      requested: 'Offen',
      active: 'Aktiv',
      denied: 'Abgelehnt',
      revoked: 'Beendet',
      expired: 'Abgelaufen',
      request_expired: 'Anfrage abgelaufen',
    },
    columns: { supporter: 'Support-Konto', requestedAt: 'Angefragt', status: 'Status', endedAt: 'Beendet' },
    success: { approved: 'Support-Zugriff freigegeben.', denied: 'Anfrage abgelehnt.', revoked: 'Support-Zugriff beendet.' },
    errors: {
      consentChanged: 'Der Zustimmungstext hat sich geändert. Bitte lies ihn erneut, bevor du freigibst.',
      selfApproval: 'Das anfragende Konto kann seine eigene Anfrage nicht freigeben.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Gesetzliche Vorgaben & Vereinbarungen',
    intro: 'Die gesetzlichen Regeln gelten automatisch und werden zentral aktuell gehalten. Hier legst du nur fest, wo dein Unternehmen davon abweicht – jede Abweichung braucht eine Grundlage, zum Beispiel einen Tarifvertrag oder eine Betriebsvereinbarung.',
    disclaimer: 'Orientierungswerte nach Gesetzeslage – keine Rechtsberatung. Tarif- und Betriebsvereinbarungen können strenger sein.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Noch nicht geprüft',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi startet mit den gesetzlichen Standardregeln. Passen sie für euch, bestätige das. Gilt bei euch ein Tarifvertrag oder eine Betriebsvereinbarung, lege unten eine Abweichung an.',
        confirm: 'Geprüft, passt für uns',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi startet mit den gesetzlichen Standardregeln – Höchstarbeitszeit, Pausen, Ruhezeit. Entscheide, was passiert, wenn eine Buchung dagegen verstößt, und bestätige dann, dass die Regeln für euch passen.',
        standard: 'Standard',
        later: 'Du kannst beides später jederzeit ändern.',
        agreements: 'Gilt bei euch ein Tarifvertrag oder eine Betriebsvereinbarung, nach der eine Regel anders oder gar nicht gilt? Dann lege unten eine {basis} an – die Hinweise richten sich danach. Einen Modus ohne Hinweise gibt es nicht.',
        agreementsBasis: 'Abweichung mit ihrer Grundlage',
        flexible: {
          personLabel: 'Die Person', personText: 'sieht beim Speichern, welche Regel um wie viel verletzt ist – die Buchung bleibt.',
          managerLabel: 'Die Führung', managerText: 'sieht die Verstöße der Woche bei der Freigabe und entscheidet mit der Person.',
          recordLabel: 'Das Protokoll', recordText: 'hält jeden Verstoß fest – für euch, nicht gegen euch.',
        },
        strict: {
          personLabel: 'Die Person', personText: 'kann eine Buchung, die eine durchgesetzte Regel verletzt, nicht speichern – und sieht, warum. Eine fehlende Pause wird gespeichert und angezeigt.',
          managerLabel: 'Die Führung', managerText: 'sieht bei der Freigabe nur noch, was trotzdem entsteht: fehlende Pausen und automatische Abschlüsse.',
          fitLabel: 'Passt, wenn', fitText: 'Ausnahmen bei euch nicht vorkommen dürfen – etwa bei Minderjährigen.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Gespeichert. Damit sind die Arbeitszeitregeln noch nicht bestätigt – bestätige jetzt, dass sie für euch passen.', confirm: 'Jetzt bestätigen' },
      confirmed: { title: 'Geprüft', body: 'Am {date} von {name} bestätigt: Die gesetzlichen Regeln passen für uns.', bodyNoName: 'Am {date} bestätigt: Die gesetzlichen Regeln passen für uns.' },
      ownDeviation: { title: 'Geprüft', body: 'Ihr habt eigene Abweichungen angelegt, die gesetzlichen Regeln sind damit angeschaut.' },
      error: 'Die Bestätigung konnte nicht gespeichert werden. Bitte versuche es noch einmal.',
    },
    noJurisdictions: 'Noch ist kein Rechtsraum festgelegt: Es gibt keine Personen mit Arbeitsort und keinen Standard-Rechtsraum. Wähle unten einen Standard, dann erscheinen hier die gesetzlichen Regeln.',
    jurisdictionEu: 'EU-Richtlinie',
    jurisdictionDefault: '{name} (Standard)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Rechtsraum {country}: Diese Regeln beurteilen gerade niemanden. | Rechtsraum {country}: Diese Regeln beurteilen die Arbeitszeit von 1 Person in Zeit, die hier arbeitet. | Rechtsraum {country}: Diese Regeln beurteilen die Arbeitszeit von {count} Personen – allen aktiven Beschäftigten in Zeit, die hier arbeiten.',
    headcountLineDefault: 'Rechtsraum {country}: Diese Regeln beurteilen gerade niemanden. | Rechtsraum {country}: Diese Regeln beurteilen die Arbeitszeit von 1 Person in Zeit, die hier arbeitet oder unter den Standard fällt. | Rechtsraum {country}: Diese Regeln beurteilen die Arbeitszeit von {count} Personen – allen aktiven Beschäftigten in Zeit, die hier arbeiten oder unter den Standard fallen.',
    fallbackLine: 'Personen ohne Arbeitsort oder mit einem Arbeitsort außerhalb des Katalogs: {count} – für sie gilt {country}.',
    createModels: 'Arbeitszeitmodelle dieses Landes anlegen',
    domains: {
      workingTime: 'Arbeitszeit',
      pay: 'Zeitfenster für Zuschläge',
      overtime: 'Überstunden',
      leave: 'Urlaub',
    },
    rules: {
      maxDailyHours: 'Tägliche Höchstarbeitszeit',
      maxWeeklyHours: 'Wöchentliche Höchstarbeitszeit',
      breaks: 'Pausen',
      minDailyRest: 'Tägliche Ruhezeit',
      nightWorkBan: 'Nachtarbeitsverbot',
      minWeeklyRest: 'Wöchentliche Ruhezeit',
      avgWeeklyHours: 'Durchschnittliche Wochenarbeitszeit',
      normalDailyHours: 'Regelarbeitszeit pro Tag',
      normalWeeklyHours: 'Regelarbeitszeit pro Woche',
      nightWindow: 'Nachtzeit für Zuschläge',
      nightCoreWindow: 'Kernnachtzeit für erhöhte Zuschläge',
      overtimeThreshold: 'Überstunden ab (Wochenstunden)',
      overtimeSurcharge: 'Überstundenzuschläge',
      minLeaveDays: 'Mindesturlaub pro Jahr',
    },
    kinds: {
      collectiveAgreement: 'Tarifvertrag',
      worksAgreement: 'Betriebsvereinbarung',
      authorityPermit: 'Behördliche Genehmigung',
      companyPolicy: 'Betriebliche Regelung',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} Tage',
      breakStage: '{minutes} min ab {hours} h',
      weeklyAverage: '{hours} h im Schnitt über {weeks} Wochen',
      nightWorkBan: 'keine Arbeit zwischen {start} und {end} Uhr',
      tierFirst: '{percent} % ab der ersten Überstunde',
      tierAfter: '{percent} % nach {hours} Überstunden',
      none: 'Keine Regel',
      switchedOff: 'Regel gilt nicht (ausgeschaltet)',
    },
    status: {
      statutory: 'Gesetzlich',
      noStatutoryRule: 'Keine gesetzliche Regel',
      infoOnly: 'Nur Hinweis',
      deviation: 'Abweichung',
      deviationStricter: 'Abweichung · strenger',
      deviationLooser: 'Abweichung · lockerer',
      deviationMoreFavourable: 'Abweichung · günstiger als gesetzlich',
      deviationLessFavourable: 'Abweichung · ungünstiger als gesetzlich',
      deviationEqual: 'Abweichung · wie gesetzlich',
      deviationMixed: 'Abweichung · teils strenger, teils lockerer',
      deviationMixedFavourable: 'Abweichung · teils günstiger, teils ungünstiger',
    },
    hint: {
      stricter: 'Strenger als das Gesetz – das ist mit jeder Grundlage zulässig.',
      looser: 'Lockerer als das Gesetz – das braucht einen Tarifvertrag, eine Betriebsvereinbarung oder eine behördliche Genehmigung als Grundlage.',
      moreFavourable: 'Günstiger als gesetzlich – das ist mit jeder Grundlage zulässig.',
      lessFavourable: 'Ungünstiger als gesetzlich – das braucht einen Tarifvertrag, eine Betriebsvereinbarung oder eine behördliche Genehmigung als Grundlage.',
      mixed: 'Teils strenger, teils lockerer als das Gesetz – das braucht einen Tarifvertrag, eine Betriebsvereinbarung oder eine behördliche Genehmigung als Grundlage.',
      mixedFavourable: 'Teils günstiger, teils ungünstiger als gesetzlich – das braucht einen Tarifvertrag, eine Betriebsvereinbarung oder eine behördliche Genehmigung als Grundlage.',
      equal: 'Entspricht dem gesetzlichen Wert – eine Abweichung ist dafür nicht nötig.',
      incomparable: 'Bei dieser Regel gibt es kein „strenger“ oder „lockerer“ – jede Grundlage ist möglich.',
      blocked: 'Eine betriebliche Regelung darf nicht hinter dem Gesetz zurückbleiben. Wähle als Grundlage einen Tarifvertrag, eine Betriebsvereinbarung oder eine behördliche Genehmigung – oder einen Wert, der mindestens dem Gesetz entspricht.',
    },
    table: {
      rule: 'Regel',
      applies: 'Es gilt',
      note: 'Hinweis zur Rechtslage',
      deviate: 'Abweichen',
      backToStatute: 'Zurück zum Gesetz',
      statutoryWouldBe: 'Gesetzlich wären: {value}',
      statutoryWouldBeNone: 'Gesetzlich gibt es hier keine Regel.',
      basis: 'Grundlage: {name}',
      basisWithClause: 'Grundlage: {name}, {clause}',
      coveredDeviation: 'Mit Tarifbindung {code}: {value} ({name})',
      futureDeviation: 'Ab {date}: {value} ({name})',
      fallbackApplies: 'Gesetzlich ist hier kein Zeitfenster festgelegt – dieses gilt, bis eine Vereinbarung ein anderes festlegt.',
      fallbackWouldBe: 'Gesetzlich ist hier kein Zeitfenster festgelegt – ohne die Abweichung gälte: {value}',
      editDeviationOf: 'Abweichung von „{name}“ bearbeiten',
      backToStatuteOf: 'Abweichung von „{name}“ zurück zum Gesetz',
    },
    notice: {
      fallback: 'Der Katalog der gesetzlichen Regeln ist vorübergehend nicht erreichbar. Angezeigt wird der mitgelieferte Grundstand; neuere Änderungen fehlen möglicherweise.',
      unjudged: 'Personen, für die derzeit keine gesetzliche Regel gilt: {count}. Sie haben keinen Arbeitsort, und es ist kein Standard-Rechtsraum gewählt – lege unten einen fest.',
      upcoming: 'Ab {date} ändert sich die gesetzliche Regel „{rule}“ auf: {value}.',
      upcomingNone: 'Ab {date} entfällt die gesetzliche Regel „{rule}“.',
      upcomingDeviationStays: 'Deine Abweichung bleibt bestehen.',
      reviewTitle: 'Bitte prüfen: {rule}',
      review: 'Der gesetzliche Wert hat sich geändert, seit diese Abweichung festgelegt wurde ({agreement}). Gesetzlich gilt jetzt: {statutory}. Deine Abweichung: {deviation}.',
      keepDeviation: 'Abweichung behalten',
    },
    minors: {
      title: 'Jugendliche unter 18',
      headcount: 'Personen: {count}',
      headcountNone: 'derzeit keine',
      hint: 'Für Personen unter 18 gelten diese gesetzlichen Jugendschutzregeln anstelle der allgemeinen – automatisch, anhand des Geburtsdatums in Personal. Vereinbarungen weichen davon nicht ab.',
      generalApplies: 'Noch keine eigene Regel – bis dahin gilt die allgemeine.',
      upcoming: 'Ab {date}: {value}',
      upcomingNone: 'Ab {date} entfällt diese Jugendschutzregel.',
    },
    form: {
      value: 'Abweichender Wert',
      daysUnit: 'Tage',
      stageAfterHours: 'Arbeitszeit von mehr als (h)',
      stageMinutes: 'Pause insgesamt (min)',
      tierAfterHours: 'Ab Überstunden pro Woche (h)',
      tierPercent: 'Zuschlag (%)',
      addStep: 'Stufe hinzufügen',
      removeStep: 'Stufe {row} entfernen',
      stageAfterHoursRow: 'Stufe {row}: Arbeitszeit von mehr als (h)',
      stageMinutesRow: 'Stufe {row}: Pause insgesamt (min)',
      tierAfterHoursRow: 'Stufe {row}: ab Überstunden pro Woche (h)',
      tierPercentRow: 'Stufe {row}: Zuschlag (%)',
      averageHours: 'Stunden pro Woche im Schnitt',
      averageWeeks: 'Ausgleichszeitraum (Wochen)',
      windowStart: 'Beginn',
      windowEnd: 'Ende',
      windowHint: 'Liegt das Ende vor dem Beginn, reicht das Fenster über Mitternacht.',
      statutoryIs: 'Gesetzlich gilt: {value}',
      comparisonBase: 'Ohne gesetzliche Regel gilt {value} – daran wird die Abweichung gemessen.',
      basis: 'Grundlage',
      basisHint: 'Die Vereinbarung, auf der die Abweichung beruht.',
      basisPick: 'Grundlage wählen…',
      basisNew: 'Neue Grundlage anlegen…',
      basisRequired: 'Bitte eine Grundlage wählen.',
      clause: 'Fundstelle',
      clauseHint: 'Wo die Regelung steht, z. B. „§ 4 Abs. 2“. Optional.',
      invalid: {
        hours: 'Bitte Stunden angeben: mehr als 0 und höchstens 168.',
        days: 'Bitte Tage angeben: mehr als 0 und höchstens 366.',
        breakLadder: 'Bitte die Stufen prüfen: 1 bis 6 Stufen, aufsteigend nach Arbeitszeit (mehr als 0 bis 24 h), Pause mehr als 0 bis 480 min und nie weniger als in der Stufe davor.',
        weeklyAverage: 'Bitte prüfen: Stunden mehr als 0 und höchstens 168, Ausgleichszeitraum 1 bis 104 Wochen.',
        timeWindow: 'Bitte Beginn und Ende als Uhrzeit angeben; sie müssen sich unterscheiden.',
        percentTiers: 'Bitte die Stufen prüfen: 1 bis 6 Stufen, die erste ab 0 Überstunden, weitere aufsteigend; Zuschlag zwischen 0 und 300 % mit höchstens zwei Nachkommastellen.',
      },
    },
    agreement: {
      name: 'Name',
      title: 'Vereinbarungen',
      subtitle: 'Tarifverträge, Betriebsvereinbarungen, Genehmigungen und betriebliche Regelungen – die Grundlagen deiner Abweichungen.',
      new: 'Neue Vereinbarung',
      edit: 'Vereinbarung bearbeiten',
      empty: 'Noch keine Vereinbarungen – es gelten überall die gesetzlichen Regeln.',
      inactive: 'Derzeit nicht gültig',
      migrated: 'Übernommen aus früheren Einstellungen',
      noDeviations: 'Noch keine Abweichungen. Lege sie oben an der jeweiligen Regel fest.',
      needsReview: 'Bitte prüfen',
      kind: 'Art der Vereinbarung',
      companyPolicyHint: 'Eine betriebliche Regelung darf nur strenger oder günstiger sein als das Gesetz.',
      nameHint: 'Zum Beispiel „Manteltarifvertrag Metall“ oder „BV Pausen 2026“.',
      nameRequired: 'Bitte der Vereinbarung einen Namen geben.',
      reference: 'Aktenzeichen / Nummer',
      referenceHint: 'Optional, z. B. Tarifregister-Nummer oder Bescheid-Nummer.',
      jurisdiction: 'Rechtsraum',
      validFrom: 'Gültig ab',
      validFromRequired: 'Bitte angeben, ab wann die Vereinbarung gilt.',
      validTo: 'Gültig bis',
      validToHint: 'Leer lassen, wenn die Vereinbarung unbefristet gilt.',
      validSince: 'gültig ab {from}',
      validRange: 'gültig {from} – {to}',
      scope: 'Gilt für',
      scopeAll: 'alle Personen dieses Rechtsraums',
      scopeCovered: 'nur Personen mit Tarifbindung',
      scopeCoveredCode: 'nur Tarifbindung {code}',
      coverageCode: 'Tarifbindungs-Code',
      coverageCodeHint: 'Der Code wird im Arbeitsvertrag einer Person in Personal hinterlegt. Die Vereinbarung gilt nur für Personen mit genau diesem Code.',
      deleteTitle: '„{name}“ löschen?',
      deleteConfirm: 'Mit der Vereinbarung werden auch ihre Abweichungen gelöscht (Anzahl: {count}). Für diese Regeln gilt danach wieder das Gesetz.',
      deleteConfirmEmpty: 'Die Vereinbarung hat keine Abweichungen; an den geltenden Regeln ändert sich nichts.',
      editDeviation: 'Abweichung bearbeiten: {rule}',
      removeDeviation: 'Zurück zum Gesetz: {rule}',
    },
    backConfirm: {
      title: '„{rule}“: zurück zum Gesetz?',
      body: 'Die Abweichung wird entfernt. Danach gilt wieder der gesetzliche Wert: {value}.',
      bodyNone: 'Die Abweichung wird entfernt. Gesetzlich gibt es hier keine Regel – danach gilt keine mehr.',
      bodyFallback: 'Die Abweichung wird entfernt. Gesetzlich gibt es hier keine Regel – danach gilt wieder {value}.',
    },
    workspace: {
      title: 'Einstellungen des Arbeitsbereichs',
      defaultJurisdiction: 'Standard-Rechtsraum',
      defaultJurisdictionHint: 'Gilt für Personen ohne Arbeitsort oder mit einem Arbeitsort, den der Katalog nicht abdeckt.',
      noDefault: 'Kein Standard',
      mode: 'Wenn eine Buchung gegen eine Regel verstößt',
      modeFlexible: 'Hinweisen und protokollieren',
      modeFlexibleHint: 'Die Buchung wird gespeichert. Der Verstoß wird angezeigt und festgehalten.',
      modeStrict: 'Buchung blockieren',
      modeStrictHint: 'Eine Buchung, die gegen eine durchgesetzte Regel verstößt, lässt sich nicht speichern.',
      originSignup: 'Übernommen aus dem Land, das dein Unternehmen bei der Registrierung angegeben hat: {country}.',
      originFallbackPrevious: 'Bis das Land, das dein Unternehmen bei der Registrierung angegeben hat, bekannt ist und im Katalog steht, gelten die Regeln für {current} – die Regeln, nach denen dieser Workspace bisher beurteilt wurde.',
      originFallbackUnknown: 'Das Land deines Unternehmens ist noch nicht bekannt. Deshalb gilt das EU-Minimum, bis hier jemand das Land auswählt.',
      originFallbackUncovered: 'Bei der Registrierung hat dein Unternehmen {country} angegeben. Dafür enthält der Katalog noch keine Regeln, deshalb gilt das EU-Minimum.',
      originFallbackCovered: 'Bei der Registrierung hat dein Unternehmen {country} angegeben; dessen Regeln stehen inzwischen im Katalog. Wähle es hier aus, um sie anzuwenden – bis dahin gilt das EU-Minimum.',
    },
    toast: {
      settingsSaved: 'Einstellungen gespeichert',
      deviationSaved: 'Abweichung gespeichert',
      deviationConfirmed: 'Abweichung bestätigt',
      backToStatute: 'Abweichung entfernt – es gilt wieder das Gesetz',
      agreementSaved: 'Vereinbarung gespeichert',
      agreementDeleted: 'Vereinbarung gelöscht',
      modelsCreated: 'Neu angelegte Arbeitszeitmodelle: {count}',
      modelsExist: 'Die Arbeitszeitmodelle dieses Landes sind bereits vorhanden.',
    },
    errors: {
      rival: '„{name}“ legt diese Regel bereits für dieselben Personen in einem überlappenden Zeitraum fest.',
      validToBeforeFrom: 'Das Ende der Gültigkeit darf nicht vor dem Beginn liegen.',
      coverageCodeRequired: 'Bitte den Tarifbindungs-Code angeben, für den die Vereinbarung gilt.',
      invalidValue: 'Der Wert ist für diese Regel nicht zulässig. Bitte prüfen.',
      jurisdictionUnknown: 'Dieser Rechtsraum ist im Katalog der gesetzlichen Regeln nicht enthalten.',
      dateInvalid: 'Bitte ein gültiges Datum angeben.',
      labelInvalid: 'Bitte die Textfelder prüfen: Der Name ist Pflicht, und kein Feld darf länger als 160 Zeichen sein.',
      noModelPresets: 'Für dieses Land gibt es keine vorbereiteten Arbeitszeitmodelle.',
      kindInvalid: 'Bitte die Art der Vereinbarung aus der Liste wählen.',
      modeInvalid: 'Bitte wählen, was geschieht, wenn eine Buchung gegen eine Regel verstößt.',
      ruleUnknown: 'Diese Version der App kennt diese Regel nicht. Bitte lade die Seite neu.',
      ruleInfoOnly: 'Diese Regel dient nur zur Information – davon lässt sich nicht abweichen.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Zeit ist in diesem Workspace nicht aktiv',
      timeInactive: 'Die gesetzlichen Vorgaben gelten für die Arbeitszeit, die in Zeit erfasst wird. Sobald Zeit zu diesem Workspace gehört, legst du hier fest, wo dein Unternehmen davon abweicht.',
      noAccess: 'Du kannst die gesetzlichen Vorgaben dieses Workspace nicht verwalten. Das können der Workspace-Inhaber, die Suite-Administration und Mitglieder von Zeit mit der Berechtigung, Compliance zu verwalten.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Ausbildungsberufe',
    columns: {
      occupation: 'Ausbildungsberuf',
      duration: 'Dauer',
      regulation: 'Ausbildungsordnung',
      apprentices: 'Azubis',
    },
    duration: '{count} Monate',
    regulationIssued: 'vom {date}',
    regulationValidFrom: 'in Kraft seit {date}',
    areas: {
      IH: 'Industrie und Handel (IHK)',
      Hw: 'Handwerk (HWK)',
      oeD: 'Öffentlicher Dienst',
      Lw: 'Landwirtschaft',
      FB: 'Freie Berufe',
      Hausw: 'Hauswirtschaft',
      See: 'Seeschifffahrt',
    },
    branches: {
      specialisations: 'Fachrichtungen',
      focuses: 'Schwerpunkte',
      any: 'Fachrichtungen / Schwerpunkte',
    },
    requirements: {
      onWall: 'Berufsbildpositionen auf der Skill-Wand: {count}',
      version: 'Verordnung vom {date}',
      none: 'Die Berufsbildpositionen der Ausbildungsordnung liegen noch nicht vor. Sie erscheinen auf der Skill-Wand, sobald der Plattformbetreiber sie importiert hat.',
      versions: 'Azubis lernen nach {count} Fassungen der Verordnung – für alle gilt jeweils die Fassung, die bei ihrem Ausbildungsbeginn in Kraft war.',
    },
    state: {
      notSelectable: 'Nicht mehr auswählbar',
      notSelectableHint: 'Der Plattformbetreiber bietet diesen Beruf nicht mehr zur Neuauswahl an. Dein Workspace behält ihn und seine Azubis – wenn du ihn entfernst, lässt er sich aber nicht wieder hinzufügen.',
      withdrawn: 'Anerkennung aufgehoben',
      withdrawnHint: 'Die staatliche Anerkennung dieses Berufs wurde aufgehoben, oder er steht nicht mehr im Verzeichnis der anerkannten Ausbildungsberufe. Laufende Ausbildungen werden zu Ende geführt; hinzufügen lässt er sich nicht mehr.',
      unknown: 'Nicht im Katalog',
      unknownHint: 'Dieser Eintrag wurde eingetippt, bevor es den Katalog gab, und passt zu keinem seiner Berufe. Er lässt sich nur entfernen – füge stattdessen den passenden Beruf aus dem Katalog hinzu.',
    },
    offered: {
      title: 'Unser Angebot',
      intro: 'Die anerkannten Ausbildungsberufe, in denen dein Unternehmen ausbildet. Nur sie stehen für Azubis zur Auswahl.',
      emptyTitle: 'Noch kein Ausbildungsberuf im Angebot',
      empty: 'Wähle unten im Katalog die Berufe aus, in denen dein Unternehmen ausbildet. Danach kannst du sie deinen Azubis zuordnen.',
      browse: 'Aus dem Katalog wählen',
      remove: 'Entfernen',
      removeNamed: '{title} aus dem Angebot entfernen',
    },
    catalogue: {
      title: 'Aus dem Katalog hinzufügen',
      intro: 'Die in Deutschland anerkannten Ausbildungsberufe, die dein Workspace noch nicht anbietet. Der Katalog wird zentral aktuell gehalten.',
      unavailableTitle: 'Der Katalog ist gerade nicht erreichbar',
      unavailable: 'Dein Angebot oben wird aus dem angezeigt, was dieser Workspace gespeichert hat. Berufe lassen sich wieder hinzufügen, sobald der Katalog zurück ist.',
      allOffered: 'Dein Workspace bietet bereits alle Berufe aus dem Katalog an.',
      searchPlaceholder: 'Titel oder Fachrichtung',
      areaLabel: 'Bereich',
      areaAll: 'Alle Bereiche',
      count: 'Gefundene Berufe: {shown} von {total}',
      noMatches: 'Kein Beruf passt zu deiner Suche.',
      resetFilters: 'Suche zurücksetzen',
      showMore: 'Mehr anzeigen',
      add: 'Hinzufügen',
      addNamed: '{title} zum Angebot hinzufügen',
    },
    removeConfirm: {
      title: '„{title}“ aus dem Angebot entfernen?',
      apprentices: 'Azubis, die diesem Beruf derzeit zugeordnet sind: {count}. Sie behalten ihren Beruf und beenden ihre Ausbildung – er kann nur für neue Azubis nicht mehr gewählt werden.',
      final: 'Einmal entfernt, lässt sich dieser Beruf nicht wieder hinzufügen.',
      confirm: 'Aus dem Angebot entfernen',
    },
    toast: {
      added: '„{title}“ gehört jetzt zu deinem Angebot',
      removed: '„{title}“ wird nicht mehr angeboten',
    },
    errors: {
      notOfferable: '„{title}“ ließ sich nicht hinzufügen: Der Beruf wurde inzwischen abgeschaltet oder aufgehoben. Die Liste wurde aktualisiert.',
      catalogueUnavailable: 'Der Katalog ist gerade nicht erreichbar, deshalb lässt sich nichts hinzufügen. Bitte versuche es später noch einmal.',
    },
    page: {
      moduleInactiveTitle: 'Ausbildung ist in diesem Workspace nicht aktiv',
      moduleInactive: 'Ausbildungsberufe werden für die Azubis angeboten, die im Modul Ausbildung verwaltet werden. Sobald es zu diesem Workspace gehört, wählst du hier, in welchen Berufen dein Unternehmen ausbildet.',
      noAccess: 'Du kannst die Ausbildungsberufe dieses Workspace nicht verwalten. Das können der Workspace-Inhaber, die Suite-Administration und Mitglieder des Moduls Ausbildung mit der Berechtigung, es zu verwalten (die Ausbildungsleitung).',
    },
  },
};
